/* Velvet Shieldz configurator — extracted from snippets/product-info.liquid.
   Faithful 1:1 move of the former inline IIFE. NO logic changes.
   Reads per-block state from window["CFG_DATA_" + BLOCK_ID] emitted inline by the snippet. */
(function () {
  function cfgLog()  { if (window.cfgDebug) { try { console.log.apply(console, arguments); }  catch (e) {} } }
  function cfgWarn() { if (window.cfgDebug) { try { console.warn.apply(console, arguments); } catch (e) {} } }
  function initConfigurator(root) {
    if (!root || root.dataset.cfgInit === "1") return;
    var BLOCK_ID = root.id.replace("configurator-", "");
    var data = window["CFG_DATA_" + BLOCK_ID];
    if (!data) return;
    root.dataset.cfgInit = "1";
    cfgLog("[velvetshieldz] IIFE init starting");
                // priceScope: the nearest ancestor of `root` that ALSO contains the price
                // block. The data-cfg-price-* spans live in the price block branch at
                // product-info.liquid:48-53 as siblings of the configurator div, both inside
                // <safe-sticky class="product-info"> (L3). root.querySelector(...) would
                // miss them. The cascade picks .product-info first (Vitals/theme convention),
                // safe-sticky second (the actual wrapper tag), parentElement third (generic),
                // document as the final fallback.
                var priceScope = root.closest('.product-info') || root.closest('safe-sticky') || root.parentElement || document;
                cfgLog('[cfg-debug] priceScope resolved to:', priceScope.tagName, priceScope.className || '(no class)');

                if (!window.__velvetCloudinaryLoaded) {
                  window.__velvetCloudinaryLoaded = true;
                  var s = document.createElement('script');
                  s.src = 'https://upload-widget.cloudinary.com/global/all.js';
                  s.async = true;
                  s.onload = function () { cfgLog('[configurator] Cloudinary widget script loaded'); };
                  s.onerror = function () { cfgWarn('[configurator] Cloudinary widget script failed to load'); };
                  document.head.appendChild(s);
                }

                var cloudName = data.cloudName;
                var uploadPreset = data.uploadPreset;
                var upgradeProductHandle = data.upgradeProductHandle;
                var replaceLabel = data.replaceLabel;
                var uploadLabel = data.uploadLabel;
                // Product form ID — emitted by Liquid (captured at product-info.liquid:1 as
                // `product-form-<product.id>-<section.id>`). Used by resolveCartForm() below as
                // the primary lookup since direct getElementById is bulletproof. The form is
                // rendered by Shopify's product form Liquid tag in buy-buttons.liquid:29 with
                // this exact id attribute (and is="product-form" for autonomous customization).
                var productFormId = data.productFormId;

                // Resolve the cart form via a cascade of strategies. The old selector
                // `form[action^="/cart/add"] input[name="id"]` failed because the active
                // `<input name="id">` lives in variant-picker.liquid:137 OUTSIDE the form
                // (linked via the HTML5 `form="..."` attribute), and the standalone
                // `form[action^="/cart/add"]` also returned null on the live theme. Each
                // strategy below is a self-contained query — first non-null wins. Strategy 1
                // is the canonical path; the others are defense-in-depth in case of unusual
                // markets/templating that prevent ID match.
                function resolveCartForm() {
                  var f = null;
                  if (productFormId) {
                    f = document.getElementById(productFormId);
                    if (f && f.tagName === 'FORM') return f;
                  }
                  f = document.querySelector('form[is="product-form"]');
                  if (f) return f;
                  f = document.querySelector('form[action*="/cart/add"]');
                  if (f) return f;
                  var btn = document.querySelector('button[name="add"]');
                  if (btn) {
                    f = btn.closest('form');
                    if (f) return f;
                  }
                  // Final fallback: chase the variant-picker's <input name="id"> via its
                  // form="..." attribute (since the input is outside the form on this theme).
                  var idInput = document.querySelector('input[name="id"][form]');
                  if (idInput) {
                    var formId = idInput.getAttribute('form');
                    if (formId) {
                      f = document.getElementById(formId);
                      if (f && f.tagName === 'FORM') return f;
                    }
                  }
                  return null;
                }

                var modelSortOrder = [
                  'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17',
                  'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16',
                  'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
                  'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
                  'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13',
                  'iPhone 12 Pro Max', 'iPhone 12 Pro'
                ];

                function findOptionPosition(candidates) {
                  if (!data.options || !data.options.length) return null;
                  for (var i = 0; i < data.options.length; i++) {
                    var oname = (data.options[i].name || '').toLowerCase().trim();
                    for (var j = 0; j < candidates.length; j++) {
                      if (oname === candidates[j]) return data.options[i].position;
                    }
                  }
                  return null;
                }

                var stylePos = findOptionPosition(['style', 'iphone model', 'model']);
                var colorPos = findOptionPosition(['color', 'colour']);

                if (!stylePos || !colorPos) {
                  root.innerHTML = '<div class="cfg-empty">Configurator unavailable - this product needs Style and Color options.</div>';
                  cfgWarn('[configurator] missing Style or Color option on product');
                  return;
                }

                cfgLog('[configurator] variants loaded:', data.variants.length);
                cfgLog('[configurator] color hex map:', data.colorHexMap);

                var modelMap = {};
                var variantsWithoutImage = 0;
                for (var v = 0; v < data.variants.length; v++) {
                  var variant = data.variants[v];
                  var model = variant['option' + stylePos];
                  var color = variant['option' + colorPos];
                  if (!model || !color) continue;
                  var hex = data.colorHexMap[color];
                  if (!hex) {
                    cfgWarn('[configurator] no hex mapping for color:', color);
                    continue;
                  }
                  if (!modelMap[model]) modelMap[model] = [];
                  var hasOwnImage = !!(variant.featured_image && variant.featured_image.src);
                  var img = hasOwnImage ? variant.featured_image.src : (productFeaturedImageUrl || null);
                  if (!hasOwnImage) variantsWithoutImage++;
                  modelMap[model].push({
                    colorName: color,
                    colorHex: hex,
                    variantId: variant.id,
                    image: img,
                    available: !!variant.available
                  });
                }
                if (variantsWithoutImage > 0) {
                  cfgLog('[configurator] ' + variantsWithoutImage + ' variant(s) without featured_image - using product fallback for those');
                }

                function sortModels(keys) {
                  var orderIndex = {};
                  modelSortOrder.forEach(function (m, i) { orderIndex[m] = i; });
                  return keys.slice().sort(function (a, b) {
                    var ia = (a in orderIndex) ? orderIndex[a] : 9999;
                    var ib = (b in orderIndex) ? orderIndex[b] : 9999;
                    if (ia !== ib) return ia - ib;
                    return a.localeCompare(b);
                  });
                }

                var sortedModels = sortModels(Object.keys(modelMap));
                cfgLog('[configurator] models:', sortedModels);

                if (!sortedModels.length) {
                  root.innerHTML = '<div class="cfg-empty">Configurator not yet set up. Add color hex mappings in the theme editor that match your variants Color option values.</div>';
                  return;
                }

                var dropdown    = root.querySelector('.cfg-dropdown');
                var trigger     = root.querySelector('.cfg-dropdown__trigger');
                var triggerLbl  = root.querySelector('.cfg-dropdown__label');
                var menu        = root.querySelector('.cfg-dropdown__menu');
                var swatchesEl  = root.querySelector('.cfg-swatches');
                var colorNameEl = root.querySelector('.cfg-color-name');
                var pills       = root.querySelectorAll('.cfg-pill');
                var panelText   = root.querySelector('.cfg-panel--text');
                var panelImage  = root.querySelector('.cfg-panel--image');
                var textOptions = root.querySelector('.cfg-text-options');
                var sizeEl      = root.querySelector('.cfg-size');
                var textarea    = root.querySelector('.cfg-textarea');
                var uploadBtn   = root.querySelector('.cfg-upload__btn');
                var uploadLbl   = root.querySelector('.cfg-upload__label');
                var uploadThumb = root.querySelector('.cfg-upload__thumb');
                var mobileFileInput = root.querySelector('.cfg-mobile-file');
                var errorBannerEl = root.querySelector('.cfg-error-banner');

                // Visible error helper — for environments where the customer can't open DevTools.
                // Shows a banner on the page for 15 seconds, then auto-hides.
                var errorBannerTimer = null;
                function showVisibleError(msg) {
                  console.error('[configurator] visible error:', msg);
                  if (!errorBannerEl) return;
                  errorBannerEl.textContent = msg;
                  errorBannerEl.style.display = 'block';
                  if (errorBannerTimer) clearTimeout(errorBannerTimer);
                  errorBannerTimer = setTimeout(function () {
                    if (errorBannerEl) errorBannerEl.style.display = 'none';
                    errorBannerTimer = null;
                  }, 15000);
                }
                function hideVisibleError() {
                  if (errorBannerEl) errorBannerEl.style.display = 'none';
                  if (errorBannerTimer) { clearTimeout(errorBannerTimer); errorBannerTimer = null; }
                }
                var noteWrap    = root.querySelector('.cfg-note');
                var noteInput   = root.querySelector('.cfg-note-input');
                var fontError   = root.querySelector('.cfg-font-error');
                var textError   = root.querySelector('.cfg-text-error');

                var propType     = root.querySelector('.cfg-prop-ptype');
                var propText     = root.querySelector('.cfg-prop-text');
                var propImage    = root.querySelector('.cfg-prop-image');
                var propFont     = root.querySelector('.cfg-prop-font');
                var propMockup   = root.querySelector('.cfg-prop-mockup');

                var mainImg = document.querySelector('[data-configurator-main-image="true"]');
                if (!mainImg) {
                  cfgWarn('[configurator] main gallery image not found - image swap disabled');
                } else {
                  cfgLog('[configurator] main gallery image element found');
                  mainImg.style.transition = 'opacity 220ms ease';
                }

                // Find the active <input name="id"> for the cart form. Prefer the variant
                // picker's input (which lives outside the form, linked via form="..." attribute)
                // since the in-form input at buy-buttons.liquid:30 is disabled when a
                // variant-picker block exists. Falls back to any name="id" input scoped to the
                // resolved cart form, then any unscoped one as a last resort.
                var resolvedCartFormForVariantInput = resolveCartForm();
                var variantInput =
                  (resolvedCartFormForVariantInput
                    ? document.querySelector('input[name="id"][form="' + resolvedCartFormForVariantInput.id + '"]:not([disabled])')
                      ?? resolvedCartFormForVariantInput.querySelector('input[name="id"]:not([disabled])')
                    : null)
                  ?? document.querySelector('input[name="id"]:not([disabled])');
                if (!variantInput) {
                  cfgWarn('[configurator] cart form input[name="id"] not found - variant id will not be updated');
                }

                // =====================================================================
                // LIVE PREVIEW (Phase 1a) - text overlay on a canvas that replaces the
                // main hero img. Activated only when enable_live_preview is true AND we
                // can locate [data-configurator-main-image="true"] in the DOM.
                // =====================================================================
                var enableLivePreview = data.enableLivePreview;
                var textAreaXPct      = data.textArea.x;
                var textAreaYPct      = data.textArea.y;
                var textAreaWidthPct  = data.textArea.width;
                var textAreaHeightPct = data.textArea.height;
                var imageAreaXPct      = data.imageArea.x;
                var imageAreaYPct      = data.imageArea.y;
                var imageAreaWidthPct  = data.imageArea.width;
                var imageAreaHeightPct = data.imageArea.height;
                var sliderDefault     = data.sizeSliderDefault;
                var defaultFontFamily = data.defaultFontFamily;
                var defaultFontName   = data.defaultFontName;
                var productFeaturedImageUrl = data.featuredImage;

                var fontDropdown  = root.querySelector('.cfg-font-dropdown');
                // document scope — desktop size slider lives in snippets/media.liquid,
                // outside the configurator block, but shares the same .cfg-size__slider class.
                var sizeSliders   = document.querySelectorAll('.cfg-size__slider');
                // document scope (not root) — desktop position slider lives in snippets/media.liquid,
                // outside the configurator block.
                var positionSliders = document.querySelectorAll('[data-cfg-position-y]');
                var originalImg   = mainImg;
                var previewCanvas = null;
                var previewCtx    = null;
                var mobilePreviewCanvas = null;
                var mobilePreviewCtx    = null;
                var sourceImage   = null;
                // Decoded variant images keyed by URL, crossOrigin-consistent with the canvas
                // loader so preloads are reusable. Lets a tab-switch swap the case image
                // synchronously instead of waiting on a fresh CORS network fetch (~0.8s).
                var variantImageCache = {};
                var livePreviewActive = false;
                var renderRafId   = null;

                function initLivePreview() {
                  if (!enableLivePreview) return;
                  if (!originalImg) {
                    cfgWarn('[configurator] [data-configurator-main-image] not found - live preview disabled, falling back to img mode');
                    return;
                  }
                  if (typeof HTMLCanvasElement === 'undefined') {
                    cfgWarn('[configurator] canvas not supported - live preview disabled');
                    return;
                  }
                  previewCanvas = document.createElement('canvas');
                  previewCanvas.setAttribute('data-configurator-preview-canvas', 'true');
                  previewCanvas.setAttribute('role', 'img');
                  previewCanvas.setAttribute('aria-label', 'Live preview of your personalized case');
                  previewCanvas.style.cssText = 'width: 100%; height: auto; display: block;';
                  originalImg.parentNode.insertBefore(previewCanvas, originalImg);
                  originalImg.style.display = 'none';
                  previewCtx = previewCanvas.getContext('2d');

                  // Mobile preview canvas (rendered into the configurator UI below the size slider)
                  mobilePreviewCanvas = root.querySelector('[data-configurator-mobile-preview]');
                  if (mobilePreviewCanvas) {
                    mobilePreviewCtx = mobilePreviewCanvas.getContext('2d');
                    cfgLog('[configurator] mobile preview canvas attached');
                  }

                  livePreviewActive = true;
                  cfgLog('[configurator] live preview enabled - canvas swap complete');
                }

                function loadVariantImageToCanvas(imageUrl) {
                  if (!previewCanvas || !imageUrl) return;
                  var cached = variantImageCache[imageUrl];
                  // Already decoded (preloaded or seen before) → swap + render synchronously, so a
                  // tab-switch updates the case image immediately with no network wait, no fade.
                  if (cached && cached.complete && cached.naturalWidth > 0) {
                    sourceImage = cached;
                    renderPreview();
                    return;
                  }
                  var img = cached ?? new Image();
                  if (!cached) {
                    img.crossOrigin = 'anonymous';
                    variantImageCache[imageUrl] = img;
                  }
                  img.onload = function () {
                    sourceImage = img;
                    cfgLog('[configurator] variant image loaded:', imageUrl, 'dimensions:', img.naturalWidth + 'x' + img.naturalHeight);
                    renderPreview();
                  };
                  img.onerror = function () {
                    cfgWarn('[configurator] variant image failed to load:', imageUrl);
                    if (previewCanvas) previewCanvas.style.display = 'none';
                    if (originalImg) {
                      originalImg.style.display = '';
                      originalImg.src = imageUrl;
                    }
                  };
                  img.src = imageUrl;
                }

                function scheduleRender() {
                  if (renderRafId) cancelAnimationFrame(renderRafId);
                  renderRafId = requestAnimationFrame(function () {
                    renderPreview();
                    if (typeof updateCanvasAriaLabel === 'function') updateCanvasAriaLabel();
                    renderRafId = null;
                  });
                }

                function renderToCanvas(targetCanvas, targetCtx) {
                  if (!targetCanvas || !targetCtx || !sourceImage) return;
                  targetCanvas.width = sourceImage.naturalWidth;
                  targetCanvas.height = sourceImage.naturalHeight;
                  targetCtx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
                  targetCtx.drawImage(sourceImage, 0, 0, targetCanvas.width, targetCanvas.height);
                  if (state.personalization === 'Text' && state.textContent && state.textContent.trim()) {
                    renderTextLayer(targetCtx, targetCanvas);
                  } else if (state.personalization === 'Image') {
                    renderImageLayer(targetCtx, targetCanvas);
                  }
                }

                function renderPreview() {
                  if (!previewCanvas || !previewCtx) return;
                  renderToCanvas(previewCanvas, previewCtx);
                  if (mobilePreviewCanvas && mobilePreviewCtx) {
                    renderToCanvas(mobilePreviewCanvas, mobilePreviewCtx);
                  }
                  cfgLog('[configurator] render: text=' + JSON.stringify(state.textContent || '') + ' font=' + JSON.stringify(state.fontName) + ' scale=' + state.sizeScale + '%');
                }

                function renderTextLayer(ctx, canvas) {
                  var text = state.textContent.trim();
                  if (!text) return;

                  // Text area box (percent of canvas).
                  var area = getTextArea();
                  var areaX = canvas.width * (area.x / 100);
                  var areaY = canvas.height * (area.y / 100);
                  var areaW = canvas.width * (area.w / 100);
                  var areaH = canvas.height * (area.h / 100);

                  // Split into lines (preserves multiline text from textarea)
                  var lines = text.split('\n').filter(function (l) { return l.trim(); });
                  if (lines.length === 0) return;

                  // Slider value (0-100) maps to area fill factor (0.10 to 0.90).
                  // Slider 0   -> text fills 10% of area (genuinely tiny, still visible)
                  // Slider 50  -> text fills 50% of area (medium)
                  // Slider 100 -> text fills 90% of area (large with breathing margin)
                  var clampedSlider = Math.max(0, Math.min(100, state.sizeScale));
                  var fillFactor = 0.10 + (clampedSlider / 100) * 0.80;
                  var availableHeight = areaH * fillFactor;
                  var availableWidth = areaW * fillFactor;

                  // Initial font size: divide available height by line count, account for line spacing.
                  // Per-font multiplier reduces handwriting-font max size so tall ascenders/descenders
                  // don't visually overflow the case (sans-serif fonts at 1.0× = unchanged).
                  var lineHeightFactor = 1.0;
                  var fontSize = ((availableHeight / lines.length) / lineHeightFactor) * getCurrentSizeMultiplier();
                  ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);

                  // Step 1: Compensate for font metric padding using actual glyph bounds.
                  // EM box (fontSize) includes empty ascender/descender space; visible glyphs are ~60-75% of it.
                  // Measured PER LINE across ALL lines (same formula as the old line-0 sample);
                  // the single worst-case (smallest) scale wins so a flourish-heavy second line
                  // can't blow past the slot sized from a plain first line. A line that doesn't
                  // qualify for compensation (ink >= EM) contributes 1.0 — i.e. no enlargement.
                  // Single-line text: identical to the previous behavior by construction.
                  try {
                    var scriptFontNames = ['Pinyon Script', 'Great Vibes', 'Allura', 'Italianno', 'Dancing Script', 'Ballet'];
                    var currentFontFamily = state.fontFamily || '';
                    var isScriptFont = scriptFontNames.some(function (name) {
                      return currentFontFamily.indexOf(name) !== -1;
                    });
                    // Font-specific compensation factor:
                    //   Script fonts (Pinyon Script, etc.) — decorative width works at 0.85
                    //   Sans-serif (Montserrat, Helvetica) — tight bounds; 0.85 overshoots, use 0.70
                    var compensationMultiplier = isScriptFont ? 0.85 : 0.70;
                    var worstScale = null;
                    for (var li = 0; li < lines.length; li++) {
                      var sampleMetrics = ctx.measureText(lines[li]);
                      if (sampleMetrics.actualBoundingBoxAscent === undefined ||
                          sampleMetrics.actualBoundingBoxDescent === undefined) continue;
                      var actualGlyphHeight = sampleMetrics.actualBoundingBoxAscent + sampleMetrics.actualBoundingBoxDescent;
                      var lineScale = (actualGlyphHeight > 0 && actualGlyphHeight < fontSize)
                        ? (fontSize / actualGlyphHeight) * compensationMultiplier
                        : 1.0;
                      if (worstScale === null || lineScale < worstScale) worstScale = lineScale;
                    }
                    if (worstScale !== null && worstScale !== 1.0) {
                      fontSize = fontSize * worstScale;
                      ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                    }
                  } catch (e) {
                    cfgWarn('[configurator] actualBoundingBox metrics unavailable, using EM box sizing');
                  }

                  // Step 2: Width constraint — shrink font further if the widest line exceeds available width
                  var widestLine = 0;
                  for (var i = 0; i < lines.length; i++) {
                    var metrics = ctx.measureText(lines[i]);
                    // Use actual visible bounding box width when available — captures script-font flourishes
                    // that advance width (.width) misses. Fall back to .width on older browsers.
                    var visibleWidth = metrics.width;
                    if (typeof metrics.actualBoundingBoxLeft === 'number' &&
                        typeof metrics.actualBoundingBoxRight === 'number') {
                      var bboxWidth = Math.abs(metrics.actualBoundingBoxLeft) + metrics.actualBoundingBoxRight;
                      // Use the larger of advance width vs visible bbox — whichever is more conservative
                      if (bboxWidth > visibleWidth) visibleWidth = bboxWidth;
                    }
                    if (visibleWidth > widestLine) widestLine = visibleWidth;
                  }
                  if (widestLine > availableWidth) {
                    fontSize = fontSize * (availableWidth / widestLine);
                    ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                  }

                  // Render lines centered both horizontally and vertically within the full area
                  ctx.fillStyle = '#000';
                  ctx.textBaseline = 'middle';
                  ctx.textAlign = 'center';
                  var lineHeight = fontSize * lineHeightFactor;
                  var totalTextHeight = lineHeight * lines.length;

                  // Ink-block metrics at the final fontSize, measured under the SAME baseline/
                  // align the draw below uses ('middle'/'center'), so extents map 1:1 to draw
                  // positions. Per line: ascent/descent (containment) + the advance-vs-ink X
                  // offset (centering). Browsers without actualBoundingBox keep EM behavior.
                  var lineMetrics = [];
                  var inkTopRel = Infinity, inkBottomRel = -Infinity, inkWidest = 0;
                  try {
                    for (var li2 = 0; li2 < lines.length; li2++) {
                      var lm = ctx.measureText(lines[li2]);
                      var entry = { offsetX: 0 };
                      if (typeof lm.actualBoundingBoxLeft === 'number' &&
                          typeof lm.actualBoundingBoxRight === 'number') {
                        entry.offsetX = (lm.actualBoundingBoxRight - lm.actualBoundingBoxLeft) / 2;
                        var inkW = Math.abs(lm.actualBoundingBoxLeft) + lm.actualBoundingBoxRight;
                        if (inkW > inkWidest) inkWidest = inkW;
                      }
                      if (lm.actualBoundingBoxAscent !== undefined &&
                          lm.actualBoundingBoxDescent !== undefined) {
                        var topRel = li2 * lineHeight - lm.actualBoundingBoxAscent;
                        var botRel = li2 * lineHeight + lm.actualBoundingBoxDescent;
                        if (topRel < inkTopRel) inkTopRel = topRel;
                        if (botRel > inkBottomRel) inkBottomRel = botRel;
                      }
                      lineMetrics.push(entry);
                    }
                  } catch (e2) {
                    inkTopRel = Infinity; inkBottomRel = -Infinity;
                  }
                  var inkMetricsOk = isFinite(inkTopRel) && isFinite(inkBottomRel);

                  // Final containment clamp: if the measured ink block exceeds the area rect,
                  // shrink uniformly so ink fits fully inside. No-op for text that fits today.
                  // Ink metrics scale linearly with fontSize, so they're rescaled in place.
                  if (inkMetricsOk) {
                    var blockH = inkBottomRel - inkTopRel;
                    var containScale = 1;
                    if (blockH > areaH) containScale = areaH / blockH;
                    if (inkWidest > areaW) containScale = Math.min(containScale, areaW / inkWidest);
                    if (containScale < 1) {
                      fontSize = fontSize * containScale;
                      ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                      lineHeight = fontSize * lineHeightFactor;
                      totalTextHeight = lineHeight * lines.length;
                      inkTopRel *= containScale;
                      inkBottomRel *= containScale;
                      for (var li3 = 0; li3 < lineMetrics.length; li3++) {
                        lineMetrics[li3].offsetX *= containScale;
                      }
                    }
                  }

                  // textPositionY: 0 = top, 50 = centered (default), 100 = bottom of design area.
                  var positionRatio = (state.textPositionY ?? 50) / 100;
                  var verticalSpace = Math.max(0, areaH - totalTextHeight);
                  var startY = areaY + (lineHeight / 2) + (positionRatio * verticalSpace);
                  if (inkMetricsOk) {
                    if (verticalSpace === 0) {
                      // EM box taller than the area — previously the slider went dead and ink
                      // could spill. Position the INK block instead, with real slider travel
                      // over whatever ink room exists.
                      var inkRoom = Math.max(0, areaH - (inkBottomRel - inkTopRel));
                      startY = (areaY - inkTopRel) + (positionRatio * inkRoom);
                    } else {
                      // EM-based placement (identical to before for text that fits), then shift
                      // only if the ink would spill past an area edge. Top edge wins.
                      var spillBottom = (startY + inkBottomRel) - (areaY + areaH);
                      if (spillBottom > 0) startY -= spillBottom;
                      var spillTop = areaY - (startY + inkTopRel);
                      if (spillTop > 0) startY += spillTop;
                    }
                  }
                  var centerX = areaX + (areaW / 2);
                  for (var j = 0; j < lines.length; j++) {
                    // Ink-centering: with textAlign 'center' the anchor centers the ADVANCE
                    // width; shifting by (bboxRight - bboxLeft)/2 centers the visible ink
                    // (~0 for metric-normal fonts, the whole fix for asymmetric bearings).
                    var drawOffsetX = lineMetrics[j] ? lineMetrics[j].offsetX : 0;
                    ctx.fillText(lines[j], centerX - drawOffsetX, startY + (j * lineHeight));
                  }
                }

                // Phase 1b: cache the decoded Image so we don't re-decode the dataURL every frame.
                var processedImageCache = null;
                var processedImageCacheUrl = null;

                function renderImageLayer(ctx, canvas) {
                  // Image area box (percent of canvas).
                  var area = getImageArea();
                  var areaX = canvas.width * (area.x / 100);
                  var areaY = canvas.height * (area.y / 100);
                  var areaW = canvas.width * (area.w / 100);
                  var areaH = canvas.height * (area.h / 100);

                  if (state.imageProcessing) {
                    ctx.save();
                    ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
                    ctx.fillRect(areaX, areaY, areaW, areaH);
                    ctx.fillStyle = '#fff';
                    ctx.font = (areaH * 0.08) + 'px sans-serif';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText('Processing image...', areaX + areaW / 2, areaY + areaH / 2);
                    ctx.restore();
                    return;
                  }

                  if (state.imageProcessError) {
                    ctx.save();
                    ctx.globalAlpha = 0.4;
                    ctx.fillStyle = '#822';
                    ctx.fillRect(areaX, areaY, areaW, areaH);
                    ctx.restore();
                    return;
                  }

                  if (!state.imageProcessedDataUrl) return;

                  if (processedImageCacheUrl !== state.imageProcessedDataUrl) {
                    processedImageCache = new Image();
                    processedImageCacheUrl = state.imageProcessedDataUrl;
                    processedImageCache.onload = function () { renderPreview(); };
                    processedImageCache.src = state.imageProcessedDataUrl;
                    return;
                  }

                  if (!processedImageCache.complete || processedImageCache.naturalWidth === 0) return;

                  var imgW = processedImageCache.naturalWidth;
                  var imgH = processedImageCache.naturalHeight;
                  // Image safe area is the full image-area box. safeH === areaH and
                  // bottomClampY === safeBottomY.
                  var safeTopY = areaY;
                  var safeBottomY = areaY + areaH;
                  var bottomClampY = safeBottomY;
                  var safeH = Math.max(0, safeBottomY - safeTopY);

                  // Size: maxScale fits the image inside the (width-bound, safeH-bound) area.
                  // Shared formula across both modes — only safeH and safeTopY differ by mode.
                  // The WIDTH bound carries the same 0.90 breathing margin text gets via its max
                  // fillFactor — landscape images no longer saturate the full box width at max.
                  // Height term unchanged: portrait/square images scale identically to before.
                  var sizeRatio = (state.imageSize ?? 100) / 100;
                  var maxScale = Math.min((0.90 * areaW) / imgW, safeH / imgH);
                  var scale = maxScale * sizeRatio;
                  var drawW = imgW * scale;
                  var drawH = imgH * scale;
                  // Vertical position: 0 = top (with overflow buffer), 50 = center, 100 = bottom.
                  // The buffer keeps the slider effective at size 100% (where safeH - drawH = 0).
                  var positionRatio = (state.imagePositionY ?? 50) / 100;
                  var positionBuffer = safeH * 0.10;
                  var drawX = areaX + (areaW - drawW) / 2;
                  var drawY;
                  var clampTopY;
                  var clampBottomY;

                  // Image mode always uses case-body-relative travel so the position slider gives
                  // a meaningful, consistent range at ALL image sizes — the slider moves the image
                  // between just-under-the-camera and the lower case body, regardless of size.
                  var useCaseBodyTravel = true;

                  if (useCaseBodyTravel) {
                    var travelTopPx = canvas.height * (CASE_TRAVEL_TOP_PERCENT / 100);
                    var travelBottomPx = canvas.height * (CASE_TRAVEL_BOTTOM_PERCENT / 100);
                    var travelRange = travelBottomPx - travelTopPx - drawH;
                    if (travelRange > 0) {
                      drawY = travelTopPx + (positionRatio * travelRange);
                    } else {
                      // Image taller than the entire travel zone — center it within the zone.
                      drawY = (travelTopPx + travelBottomPx - drawH) / 2;
                    }
                    clampTopY = travelTopPx;
                    clampBottomY = travelBottomPx;
                  }

                  // Hard clamps — image never crosses the active top/bottom bounds (the
                  // case-body travel-zone edges).
                  if (drawY < clampTopY) drawY = clampTopY;
                  if (drawY + drawH > clampBottomY) drawY = clampBottomY - drawH;
                  // Horizontal mirror of the Y clamps — drawX is centered and drawW is bounded
                  // above, so today this is a no-op; it hard-guards the area edges regardless.
                  if (drawX < areaX) drawX = areaX;
                  if (drawX + drawW > areaX + areaW) drawX = areaX + areaW - drawW;

                  // Multiply blend integrates the grayscale image with the case texture below.
                  //   Dark grayscale pixels → strong darkening (deep engraving look)
                  //   Light grayscale pixels → barely affects the case (light/no engraving)
                  //   Transparent pixels (bg-removed) → no effect
                  // globalAlpha multiplied by state.imageOpacity drives the 300ms fade-in
                  // when bg-removal completes (reset to 1 by remove handler).
                  ctx.save();
                  ctx.globalAlpha = ctx.globalAlpha * (state.imageOpacity ?? 1);
                  ctx.globalCompositeOperation = 'multiply';
                  ctx.drawImage(processedImageCache, drawX, drawY, drawW, drawH);
                  ctx.restore();
                }

                function initialRenderTrigger() {
                  if (livePreviewActive) scheduleRender();
                }

                function setMainImage(url) {
                  if (!url) return;
                  if (livePreviewActive) {
                    loadVariantImageToCanvas(url);
                    return;
                  }
                  if (!originalImg) {
                    cfgLog('[configurator] no image for selected variant - keeping current main image');
                    return;
                  }
                  cfgLog('[configurator] main image ->', url);
                  originalImg.style.transition = 'opacity 120ms ease-out';
                  originalImg.style.opacity = '0';
                  setTimeout(function () {
                    originalImg.removeAttribute('srcset');
                    originalImg.src = url;
                    originalImg.style.opacity = '1';
                  }, 60);
                }

                function preloadModelImages(modelName) {
                  var variantsForModel = modelMap[modelName] ?? [];
                  variantsForModel.forEach(function (entry) {
                    if (entry.image && !variantImageCache[entry.image]) {
                      var img = new Image();
                      // crossOrigin MUST match loadVariantImageToCanvas, else this preload sits in a
                      // separate (non-CORS) cache entry the canvas loader can't reuse — which is what
                      // forced the re-fetch + delay on every case switch.
                      img.crossOrigin = 'anonymous';
                      img.decoding = 'async';
                      variantImageCache[entry.image] = img;
                      img.src = entry.image;
                    }
                  });
                  cfgLog('[configurator] preloaded', variantsForModel.length, 'images for', modelName);
                }

                function setVariantId(id) {
                  if (!variantInput) return;
                  variantInput.value = id;
                  variantInput.removeAttribute('disabled');
                }

                var state = {
                  model: null,
                  colorEntry: null,
                  // null = no personalization mode selected (deselected). A mode becomes
                  // active only via an explicit pill click / preset pick; the displayed
                  // price then follows the 'none' tier until a mode is chosen.
                  personalization: null,
                  customerNote: '',
                  // Tiered personalization pricing — populated by fetchUpgradePrices() on init.
                  // Structure (post-fetch success):
                  //   { 'Text': {id, price, title}, 'Image': {...}, 'Text + Image': {...} }
                  // Remains null on fetch failure; UI degrades gracefully (no sub-labels, no
                  // upgrade line item on ATC — case still purchasable).
                  upgradePrices: null,
                  customImageUrl: null,
                  // Empty on load — a decoy "Choose your font" placeholder shows and the
                  // customer must actively pick a font (cart gate in the submit handler). The
                  // preview + engraving fall back to defaultFontFamily (League Spartan) so the
                  // case never renders blank while fontName stays empty for the gate.
                  fontFamily: '',
                  fontName: '',
                  textContent: '',
                  sizeScale: sliderDefault,
                  textPositionY: 50,
                  imageSize: 100,
                  imagePositionY: 50,
                  imageOpacity: 1,
                  customImageReady: false,
                  imageProcessedDataUrl: null,
                  imageProcessing: false,
                  imageProcessError: null,
                  // Set when the customer picks a preset design (sheet below the mode pills).
                  // Survives a switch to Text mode (the image state it labels also survives);
                  // the 'Design' fee tier only applies while personalization === 'Image'.
                  presetDesignName: null,
                  walletEnabled: false,
                  // null = no wallet mode selected (mirrors state.personalization). The
                  // customer must actively pick Text or Image; the wallet fee is content-
                  // gated on top of that, so null always prices as the plain wallet.
                  walletPersonalization: null,
                  walletTextContent: '',
                  walletFontName: defaultFontName,
                  walletFontFamily: defaultFontFamily,
                  walletCustomImageUrl: null,
                  walletCustomImageReady: false,
                  walletSizeScale: 50,
                  walletProcessedDataUrl: null,
                  walletImageProcessing: false,
                  walletImageProcessError: null,
                  walletMockupUrl: null
                };

                // === Input-safety constants + helpers ===
                // Hoisted to immediately-after-state so they're initialized before ANY consumer runs.

                // Tunable upload constraints — keep these in sync with backend Cloudinary preset.
                var UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
                var UPLOAD_ALLOWED_MIME = /^image\/(png|jpe?g|webp|heic|heif)$/i;
                var UPLOAD_ALLOWED_EXT  = /\.(png|jpe?g|webp|heic|heif)$/i;

                function getCurrentCharLimit() { return 60; }

                // Per-font max text-size multiplier — handwriting fonts have tall ascenders/descenders
                // that visually overflow the case at slider max; cap them at 0.75× while sans-serif
                // fonts render at full 1.0×. Applied in BOTH renderTextLayer (live preview) and
                // renderEngravingText (the captured PNG) so the laser-ready output matches preview.
                var SIZE_MULTIPLIERS = {
                  'Pinyon Script': 0.75,
                  'Great Vibes': 0.75,
                  'Allura': 0.75,
                  'Italianno': 0.75,
                  'Dancing Script': 0.75,
                  'Ballet': 0.74,
                  'Montserrat': 1.0,
                  'Helvetica': 1.0,
                  'League Spartan': 1.0,
                  'Cormorant Garamond': 0.90,
                  'Velvet Bold': 0.85,
                  'Aerosoldier': 0.82
                };
                var DEFAULT_SIZE_MULTIPLIER = 1.0;
                function getCurrentSizeMultiplier() {
                  // Defensive: same belt-and-suspenders pattern as getCurrentCharLimit.
                  if (typeof SIZE_MULTIPLIERS === 'undefined' || !state || !state.fontName) {
                    return DEFAULT_SIZE_MULTIPLIER || 1.0;
                  }
                  return SIZE_MULTIPLIERS[state.fontName] ?? DEFAULT_SIZE_MULTIPLIER ?? 1.0;
                }

                // Single Image-mode case-body-relative travel bounds. Used only when the image is
                // too large for the image-area-based slider math to have meaningful travel
                // (drawH ≥ safeH + 2*positionBuffer). Percentages of total canvas height.
                var CASE_TRAVEL_TOP_PERCENT = 38;    // image top can travel as high as ~38% (just below camera cutout)
                var CASE_TRAVEL_BOTTOM_PERCENT = 80; // image bottom can travel as low as ~80% (calibration iteration 2 after visual review; 85 overhung the case, 78 stopped short)
                function autoResizeTextarea(el) {
                  if (!el) return;
                  el.style.height = 'auto';
                  el.style.height = Math.min(el.scrollHeight, 140) + 'px';
                }
                function updateCharCounter(textEl, counterEl) {
                  if (!textEl || !counterEl) return;
                  var limit = getCurrentCharLimit();
                  var len = (textEl.value || '').length;
                  counterEl.textContent = len + ' / ' + limit;
                  counterEl.classList.toggle('is-over', len >= limit);
                }

                // Crop transparent edges around the visible content so the renderer scales the
                // visible pixels (not the full alpha bounding box) to fit the safe area. Without
                // this trim, Cloudinary's bg-removed PNG keeps the original upload's dimensions
                // and the visible content can end up at a fraction of the available space.
                // Renderer math is unchanged — it consumes a smaller, tighter image. Returns the
                // source image unchanged on no-op cases (already tight, fully transparent, or
                // CORS taint); returns a fresh HTMLCanvasElement otherwise.
                function autoTrimAlpha(sourceImg, alphaThreshold) {
                  alphaThreshold = alphaThreshold ?? 10;
                  if (!sourceImg) return sourceImg;
                  var w = sourceImg.naturalWidth ?? sourceImg.width;
                  var h = sourceImg.naturalHeight ?? sourceImg.height;
                  if (!w || !h) return sourceImg;

                  var srcCanvas = document.createElement('canvas');
                  srcCanvas.width = w;
                  srcCanvas.height = h;
                  var srcCtx = srcCanvas.getContext('2d');
                  srcCtx.drawImage(sourceImg, 0, 0);

                  var data;
                  try {
                    data = srcCtx.getImageData(0, 0, w, h).data;
                  } catch (e) {
                    // CORS taint — return original, renderer continues with current behavior.
                    return sourceImg;
                  }

                  var minX = w, minY = h, maxX = -1, maxY = -1;
                  for (var y = 0; y < h; y++) {
                    for (var x = 0; x < w; x++) {
                      var alpha = data[(y * w + x) * 4 + 3];
                      if (alpha > alphaThreshold) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                      }
                    }
                  }

                  if (maxX < minX || maxY < minY) return sourceImg; // fully transparent
                  var cropW = maxX - minX + 1;
                  var cropH = maxY - minY + 1;
                  if (cropW === w && cropH === h) return sourceImg; // already tight

                  var cropCanvas = document.createElement('canvas');
                  cropCanvas.width = cropW;
                  cropCanvas.height = cropH;
                  cropCanvas.getContext('2d').drawImage(srcCanvas, minX, minY, cropW, cropH, 0, 0, cropW, cropH);
                  return cropCanvas;
                }

                // Build a dynamic aria-label that describes the current preview state for screen
                // readers. Both preview canvases (mobile + desktop) share the same label since
                // they render the same composition. Called from scheduleRender so it stays in
                // sync with every state-driven re-render (model/color/text/font/image change).
                function updateCanvasAriaLabel() {
                  var model = state.model ?? '';
                  var color = (state.colorEntry && state.colorEntry.colorName) ?? '';
                  var type = state.personalization;
                  var pieces = [];
                  pieces.push('Preview of ' + (model || 'iPhone') + ' case' + (color ? ' in ' + color : ''));
                  if (type == null) {
                    pieces.push('no personalization selected');
                  } else {
                    pieces.push(type + ':');
                    if (type === 'Text') {
                      var t = (state.textContent ?? '').trim();
                      pieces.push(t.length > 0 ? '"' + t + '"' : 'no text');
                      if (state.fontName) pieces.push('in ' + state.fontName);
                    }
                    if (type === 'Image' && state.customImageReady) {
                      pieces.push('uploaded image');
                    }
                  }
                  var label = pieces.join(' ');
                  if (previewCanvas) previewCanvas.setAttribute('aria-label', label);
                  if (mobilePreviewCanvas) mobilePreviewCanvas.setAttribute('aria-label', label);
                }

                // Mode-aware slider ARIA. The four sliders (mobile/desktop × position/size) all
                // edit either text or image depending on state.personalization. Updating aria-label
                // here means screen readers announce "Vertical position of image, 50 percent" when
                // the user is adjusting an image. aria-valuetext supplements the native
                // aria-valuenow (which is the raw number) with a more natural-language reading.
                function updateSliderAria() {
                  var editingImage = (typeof activeIsImage === 'function') ? activeIsImage() : false;
                  var noun = editingImage ? 'image' : 'text';
                  var posLabel = 'Vertical position of ' + noun;
                  var sizeLabel = 'Size of ' + noun;
                  document.querySelectorAll('[data-cfg-position-y]').forEach(function (s) {
                    s.setAttribute('aria-label', posLabel);
                    s.setAttribute('aria-orientation', 'vertical');
                    s.setAttribute('aria-valuetext', (s.value ?? '0') + ' percent');
                  });
                  document.querySelectorAll('.cfg-size__slider').forEach(function (s) {
                    s.setAttribute('aria-label', sizeLabel);
                    s.setAttribute('aria-valuetext', (s.value ?? '0') + ' percent');
                  });
                }

                // === Tiered personalization pricing helpers ===

                // Maps the state.personalization values ('Text' / 'Image' / 'Combined') to the
                // upgrade product's variant titles ('Text' / 'Image' / 'Text + Image'). The
                // upgrade variants must be titled exactly this way in the admin — case-sensitive.
                function tierKeyForUpgrade(personalization, presetDesignName) {
                  // Preset designs charge the 'Design' variant, but ONLY in Image mode —
                  // presetDesignName intentionally survives a switch to Text mode (its image
                  // state survives too), and a Text engraving must never charge 'Design'.
                  if (personalization === 'Image' && presetDesignName) return 'Design';
                  if (personalization === 'Combined') return 'Text + Image';
                  // null (deselected) never reaches the cart fee path (content gates return
                  // false first) — 'Text' is a harmless placeholder, not a charge.
                  return personalization ?? 'Text';
                }

                // Returns { id, price, title } for the current tier, or null if upgradePrices
                // hasn't loaded (fetch failed / hasn't resolved yet). buildCartItems relies on
                // .id; the displayed price text is rendered by Liquid (not this function).
                function getCurrentUpgrade() {
                  if (!state.upgradePrices) return null;
                  var key = tierKeyForUpgrade(state.personalization, state.presetDesignName);
                  return state.upgradePrices[key] ?? null;
                }

                // CHARGED-side content gate — the exact same rule buildCartItems uses to decide
                // wHasContent (Text: non-empty trimmed text; Image: an uploaded image URL). The
                // wallet personalization fee (the upgrade variant matching the wallet's own
                // mode — 'Text' or 'Image') is CHARGED only when this returns true. DISPLAYED totals are intentionally looser: they gate on
                // walletModeSelected() below ("committed price" — the fee shows the moment a mode
                // is picked, before content exists). The two can only disagree while content is
                // still empty, and the ATC gates (firstCaseEmptyText / firstWalletIncomplete)
                // block every such state from checking out — so displayed == charged at every
                // reachable purchase.
                // Parameterized so BOTH the active case (live state) and each saved case
                // (designs[i]) share one rule. Mirrors buildCartItems' wHasContent exactly.
                function walletFeeAppliesTo(personalization, textContent, customImageUrl) {
                  if (personalization === 'Text')  return !!(textContent ?? '').trim();
                  if (personalization === 'Image') return !!customImageUrl;
                  return false;
                }
                function walletFeeApplies() {
                  return walletFeeAppliesTo(state.walletPersonalization, state.walletTextContent, state.walletCustomImageUrl);
                }

                // DISPLAY-side mode gate: true the moment a wallet personalization mode is
                // selected, content or not. Strict equality — null (deselected) never matches,
                // so a plain wallet keeps the plain price. Drives the fee chip, the main
                // running total, the multi-case totals, and preview visibility.
                function walletModeSelected() {
                  return state.walletPersonalization === 'Text' || state.walletPersonalization === 'Image';
                }

                // Case-side twin of walletFeeAppliesTo. Image content mirrors the case props
                // gate (customImageReady, plus the URL that _Custom Image URL emits); 'Combined'
                // is a legacy tier not reachable from the pills but handled for completeness.
                function caseFeeAppliesTo(personalization, textContent, customImageUrl, customImageReady) {
                  if (personalization === 'Text')  return !!(textContent ?? '').trim();
                  if (personalization === 'Image') return !!(customImageReady && customImageUrl);
                  if (personalization === 'Combined') return !!(textContent ?? '').trim() || !!(customImageReady && customImageUrl);
                  return false;
                }

                function getCurrentWalletUpgrade() {
                  if (!state.upgradePrices) return null;
                  if (!walletFeeApplies()) return null;   // CHARGED side: fee line only when content exists (matches buildCartItems' wHasContent) — display uses walletModeSelected() instead
                  // walletFeeApplies() guarantees the mode is 'Text' or 'Image' with content,
                  // so the fee variant follows the wallet's own mode (never the case's).
                  var key = state.walletPersonalization === 'Text' ? 'Text' : 'Image';
                  return state.upgradePrices[key] ?? null;
                }

                function refreshRunningTotal() {
                  var vid = variantInput && variantInput.value;
                  if (!vid && state.colorEntry && state.colorEntry.variantId) vid = state.colorEntry.variantId;
                  if (vid != null) updatePriceForVariantAndTier(vid, state.personalization);
                }

                // Normalize incoming tier strings to the lowercase map keys 'none' / 'text' /
                // 'image' / 'combined'. null / undefined / empty = no mode selected → 'none'
                // (the base case-only price). The happy path (state.personalization ===
                // 'Text' / 'Image' / 'Combined' / null) already works, but this defensive
                // normalization handles any legacy or future input form ('Text + Image',
                // mixed case, surrounding whitespace) that might leak in via a different
                // code path.
                function normalizeTierKey(rawTier) {
                  if (rawTier == null) return 'none';
                  var t = String(rawTier).toLowerCase().trim();
                  if (t === '' || t === 'none') return 'none';
                  if (t === 'combined' || t === 'text + image' || t === 'text+image' || t === 'text + img' || (t.indexOf('image') !== -1 && t.indexOf('text') !== -1)) {
                    return 'combined';
                  }
                  if (t === 'image' || t.indexOf('image') !== -1) return 'image';
                  return 'text';
                }

                // Color/model swap OR personalization-tier swap rewrites the displayed price
                // spans with the active market's Liquid-pre-rendered strings for the new
                // (variant, tier) pair. The map at window.CFG_DATA.variantPrices was emitted at
                // page render, so every (current, compare, savings) string is already in the
                // correct currency for every tier. A currency switch reloads the page → the
                // map regenerates → JS keeps working without any JS currency conversion.
                // Tier keys are lowercase ('text' / 'image' / 'combined'); rawTier is
                // normalized via normalizeTierKey() so any input form maps correctly.
                function updatePriceForVariantAndTier(variantId, rawTier) {
                  var map = (window.CFG_DATA && window.CFG_DATA.variantPrices) ? window.CFG_DATA.variantPrices : null;
                  var tier = normalizeTierKey(rawTier);
                  cfgLog('[cfg-debug] updatePriceForVariantAndTier called', { variantId: variantId, rawTier: rawTier, normalizedTier: tier, tierType: typeof rawTier });
                  if (!map) {
                    cfgWarn('[cfg-debug] CFG_DATA.variantPrices map is missing entirely');
                    return;
                  }
                  var entry = map[String(variantId)] ?? null;
                  if (!entry) {
                    cfgWarn('[cfg-debug] No map entry for variant', variantId, '— available IDs (first 5):', Object.keys(map).slice(0, 5));
                    return;
                  }
                  var walletOn = walletHasMatch && wToggle && wToggle.checked;
                  var curSet = entry.current, cmpSet = entry.compare;
                  if (walletOn) {
                    // Mode-gated (committed price): the wallet fee shows as soon as a wallet
                    // mode is selected — the ATC gates guarantee content exists before checkout.
                    if (walletModeSelected() && entry.walletOnImg) { curSet = entry.walletOnImg.current; cmpSet = entry.walletOnImg.compare; }
                    else if (entry.walletOnNoImg) { curSet = entry.walletOnNoImg.current; cmpSet = entry.walletOnNoImg.compare; }
                  }
                  var availableTierKeys = Object.keys(entry.current || {});
                  var resolvedCurrent = curSet && curSet[tier];
                  cfgLog('[cfg-debug] map entry found. Available tier keys:', availableTierKeys, '— Lookup result for tier "' + tier + '":', resolvedCurrent);
                  // Broadened from priceScope.querySelector to document.querySelectorAll:
                  // duplicate [data-cfg-price-*] elements exist on the page (a hidden
                  // sticky/template copy is one of them), and the single-element lookup
                  // was returning the wrong duplicate so the visible span never updated.
                  // forEach over the full NodeList so EVERY copy reflects the active
                  // (variant, tier) price — visible, hidden, or future-rendered.
                  var totalEls   = document.querySelectorAll('[data-cfg-price-total]');
                  var compareEls = document.querySelectorAll('[data-cfg-price-compare]');
                  var savingsEls = document.querySelectorAll('[data-cfg-price-savings]');
                  cfgLog('[cfg-debug] DOM elements:', { total: totalEls.length, compare: compareEls.length, savings: savingsEls.length });
                  if (resolvedCurrent) {
                    totalEls.forEach(function (el) { el.innerHTML = resolvedCurrent; });
                  }
                  var cmp = cmpSet && cmpSet[tier];
                  compareEls.forEach(function (el) {
                    if (cmp) {
                      el.innerHTML = cmp;
                      el.hidden = false;
                    } else {
                      el.hidden = true;
                    }
                  });
                  var sav = entry.savings && entry.savings[tier];
                  savingsEls.forEach(function (el) {
                    if (sav) {
                      el.innerHTML = sav;
                      el.hidden = false;
                    } else {
                      el.hidden = true;
                    }
                  });
                }

                // Pill sub-label visibility toggle. Both `--inactive` ("Add for X" or "Free")
                // and `--active` ("X" or "Free") spans are pre-rendered in Liquid (already in
                // the active market's currency). JS only toggles which one is visible — no text
                // mutation, no currency formatting in JS.
                function updatePillSubLabelVisibility() {
                  var pillsList = root.querySelectorAll('.cfg-pill');
                  pillsList.forEach(function (pill) {
                    var tier = pill.getAttribute('data-personalization');
                    var isActive = (tier === state.personalization);
                    var inactiveSpan = pill.querySelector('.cfg-pill__price--inactive');
                    var activeSpan = pill.querySelector('.cfg-pill__price--active');
                    if (inactiveSpan) inactiveSpan.toggleAttribute('hidden', isActive);
                    if (activeSpan) activeSpan.toggleAttribute('hidden', !isActive);
                  });
                }

                // Fire-and-forget fetch of the personalization upgrade product. The sub-label
                // text is pre-rendered by Liquid; this fetch exists purely to resolve the
                // upgrade VARIANT IDs that buildCartItems needs to build the second line item
                // at /cart/add.js. Failure modes (404, network error, missing variant titles)
                // leave state.upgradePrices null — ATC degrades to case-only.
                function fetchUpgradePrices() {
                  if (!upgradeProductHandle) return;
                  fetch('/products/' + encodeURIComponent(upgradeProductHandle) + '.js', {
                    headers: { 'Accept': 'application/json' },
                    cache: 'no-cache'
                  })
                    .then(function (res) {
                      if (!res.ok) throw new Error('Upgrade product fetch HTTP ' + res.status);
                      return res.json();
                    })
                    .then(function (product) {
                      if (!product || !Array.isArray(product.variants)) {
                        throw new Error('Upgrade product response missing variants array');
                      }
                      var map = {};
                      product.variants.forEach(function (v) {
                        var title = (v.title ?? '').trim();
                        map[title] = { id: v.id, price: Number(v.price) || 0, title: title };
                      });
                      // 'Text + Image' was removed from the store intentionally (legacy
                      // 'Combined' tier is unreachable from the pills) — not required.
                      var requiredTiers = ['Text', 'Image', 'Design'];
                      var missing = requiredTiers.filter(function (t) { return !map[t]; });
                      if (missing.length > 0) {
                        cfgWarn('[configurator] upgrade product missing tiers:', missing.join(', '),
                          '— variants found:', product.variants.map(function (v) { return v.title; }).join(' | '));
                      }
                      state.upgradePrices = map;
                      cfgLog('[configurator] upgrade prices loaded (variant IDs for cart):', map);
                      // Upgrade prices arrive async — refresh the displayed cases total so each
                      // case's per-case upgrade is included once known.
                      if (typeof refreshCasesTotal === 'function') refreshCasesTotal();
                    })
                    .catch(function (err) {
                      cfgWarn('[configurator] upgrade product fetch failed — UI degrades, ATC will send case only:', err.message);
                      state.upgradePrices = null;
                    });
                }

                var highlightedIndex = -1;

                function buildMenu() {
                  menu.innerHTML = '';
                  sortedModels.forEach(function (m, idx) {
                    var li = document.createElement('li');
                    li.className = 'cfg-dropdown__item';
                    li.setAttribute('role', 'option');
                    li.setAttribute('aria-selected', 'false');
                    li.setAttribute('data-model', m);
                    li.setAttribute('data-index', String(idx));
                    li.textContent = m;
                    li.addEventListener('click', function (e) {
                      e.stopPropagation();
                      selectModel(m);
                      closeDropdown();
                      trigger.focus();
                    });
                    li.addEventListener('mouseenter', function () {
                      highlightedIndex = idx;
                      updateHighlight();
                    });
                    menu.appendChild(li);
                  });
                }

                function openDropdown() {
                  dropdown.classList.add('is-open');
                  trigger.setAttribute('aria-expanded', 'true');
                  highlightedIndex = sortedModels.indexOf(state.model);
                  if (highlightedIndex < 0) highlightedIndex = 0;
                  updateHighlight();
                }

                function closeDropdown() {
                  dropdown.classList.remove('is-open');
                  trigger.setAttribute('aria-expanded', 'false');
                }

                function toggleDropdown() {
                  if (dropdown.classList.contains('is-open')) closeDropdown();
                  else openDropdown();
                }

                function updateHighlight() {
                  var items = menu.querySelectorAll('.cfg-dropdown__item');
                  items.forEach(function (it, idx) {
                    it.classList.toggle('is-highlight', idx === highlightedIndex);
                  });
                  if (highlightedIndex >= 0 && items[highlightedIndex]) {
                    items[highlightedIndex].scrollIntoView({ block: 'nearest' });
                  }
                }

                function updateMenuSelectionMark() {
                  var items = menu.querySelectorAll('.cfg-dropdown__item');
                  items.forEach(function (it) {
                    it.setAttribute('aria-selected', it.getAttribute('data-model') === state.model ? 'true' : 'false');
                  });
                }

                function renderSwatches(model) {
                  swatchesEl.innerHTML = '';
                  var entries = modelMap[model] || [];
                  entries.forEach(function (entry) {
                    var b = document.createElement('button');
                    b.type = 'button';
                    b.className = 'cfg-swatch' + (entry.available ? '' : ' is-disabled');
                    b.style.background = entry.colorHex;
                    b.setAttribute('data-color', entry.colorName);
                    b.setAttribute('data-variant', String(entry.variantId));
                    b.setAttribute('aria-label', entry.colorName);
                    b.setAttribute('role', 'radio');
                    b.setAttribute('aria-checked', 'false');
                    b.setAttribute('aria-disabled', entry.available ? 'false' : 'true');
                    b.title = entry.colorName + (entry.available ? '' : ' (unavailable)');
                    if (entry.available) {
                      b.addEventListener('click', function () { selectColor(entry); });
                    }
                    swatchesEl.appendChild(b);
                  });
                }

                function setActiveSwatch(colorName) {
                  swatchesEl.querySelectorAll('.cfg-swatch').forEach(function (el) {
                    var on = (el.getAttribute('data-color') === colorName);
                    el.classList.toggle('is-active', on);
                    el.setAttribute('aria-checked', on ? 'true' : 'false');
                  });
                }

                function selectColor(entry) {
                  state.colorEntry = entry;
                  setActiveSwatch(entry.colorName);
                  colorNameEl.textContent = entry.colorName;
                  setMainImage(entry.image);
                  setVariantId(entry.variantId);
                  cfgLog('[configurator] selected variant:', entry.variantId, 'for', state.model, '/', entry.colorName);
                  // Variant changed — swap the displayed price spans to the new variant's
                  // Liquid-pre-rendered (market-aware) strings. No-op when both variants match
                  // the same map entry. Map is at window.CFG_DATA.variantPrices. Raw tier is
                  // passed as-is: normalizeTierKey maps null → 'none' (base price, no fee).
                  updatePriceForVariantAndTier(entry.variantId, state.personalization);
                  applyWalletForColor(entry);
                  refreshCasesTotal();
                }

                function selectModel(model) {
                  state.model = model;
                  triggerLbl.textContent = model;
                  updateMenuSelectionMark();
                  renderSwatches(model);
                  preloadModelImages(model);
                  var entries = modelMap[model] || [];
                  var firstAvailable = null;
                  for (var k = 0; k < entries.length; k++) {
                    if (entries[k].available) { firstAvailable = entries[k]; break; }
                  }
                  if (firstAvailable) {
                    selectColor(firstAvailable);
                  } else if (entries.length) {
                    var entry = entries[0];
                    setActiveSwatch(entry.colorName);
                    colorNameEl.textContent = entry.colorName;
                    setMainImage(entry.image);
                    cfgLog('[configurator] all colors of', model, 'are unavailable');
                    applyWalletForColor(null);
                  } else {
                    colorNameEl.textContent = '';
                    applyWalletForColor(null);
                  }
                }

                // Getters/setters route to the active mode's state fields (Text → text*, Image → image*).
                function activeIsImage() {
                  return state.personalization === 'Image';
                }
                function getCurrentSize() {
                  return activeIsImage() ? state.imageSize : state.sizeScale;
                }
                function setCurrentSize(val) {
                  if (activeIsImage()) state.imageSize = val;
                  else state.sizeScale = val;
                }
                function getCurrentPosition() {
                  return activeIsImage() ? state.imagePositionY : state.textPositionY;
                }
                function setCurrentPosition(val) {
                  if (activeIsImage()) state.imagePositionY = val;
                  else state.textPositionY = val;
                }
                // Area config for the active mode.
                function getTextArea() {
                  return { x: textAreaXPct, y: textAreaYPct, w: textAreaWidthPct, h: textAreaHeightPct };
                }
                function getImageArea() {
                  return { x: imageAreaXPct, y: imageAreaYPct, w: imageAreaWidthPct, h: imageAreaHeightPct };
                }
                // Single source of truth for size + position slider visibility.
                // Text mode → always show. Image mode → show only once a processed image is ready
                // (so empty-Image-mode + processing both correctly hide the controls).
                function shouldShowSliders() {
                  if (state.personalization === 'Text') return true;
                  if (state.personalization === 'Image' && state.customImageReady) return true;
                  return false;
                }
                function syncSlidersVisibility() {
                  var show = shouldShowSliders();
                  // Both .cfg-size (configurator block + media.liquid desktop) and .cfg-position
                  // span multiple DOM scopes — toggle via document.
                  document.querySelectorAll('.cfg-size, .cfg-position').forEach(function (el) {
                    el.hidden = !show;
                  });
                }
                // Push the active mode's stored slider values into the slider DOM nodes + their displays.
                function syncSlidersValues() {
                  var curSize = getCurrentSize();
                  var curPos  = getCurrentPosition();
                  if (sizeSliders && sizeSliders.length) {
                    sizeSliders.forEach(function (s) { s.value = curSize; });
                    document.querySelectorAll('.cfg-size__value').forEach(function (v) { v.textContent = curSize + '%'; });
                  }
                  document.querySelectorAll('[data-cfg-position-y]').forEach(function (s) { s.value = curPos; });
                  document.querySelectorAll('[data-cfg-position-y-display]').forEach(function (d) { d.textContent = curPos + '%'; });
                  if (typeof updateSliderAria === 'function') updateSliderAria();
                }

                function selectPersonalization(type) {
                  // type: 'Text' | 'Image' | null. null = deselected (no mode active) —
                  // no pill lit, both panels hidden, all prop inputs disabled, 'none' tier
                  // price. Content state (textContent / customImageUrl / presetDesignName)
                  // is RETAINED so re-selecting a mode restores it. propType is written
                  // per-branch below (it ships disabled + empty from Liquid).
                  state.personalization = type;
                  pills.forEach(function (p) {
                    var on = (type != null && p.getAttribute('data-personalization') === type);
                    p.classList.toggle('is-active', on);
                    p.setAttribute('aria-pressed', on ? 'true' : 'false');
                    // Red "remove" X badge on the selected pill — purely visual
                    // (pointer-events: none in CSS; no handler of its own, clicks fall
                    // through to this pill's existing toggle-off). Synced here so it
                    // always tracks the ACTIVE case's mode: case switches re-enter via
                    // selectPersonalization(state.personalization), never a global flag.
                    var xBadge = p.querySelector('.cfg-pill__x');
                    if (on) {
                      if (!xBadge) {
                        xBadge = document.createElement('span');
                        xBadge.className = 'cfg-pill__x';
                        xBadge.setAttribute('aria-hidden', 'true');
                        xBadge.textContent = '×';
                        p.appendChild(xBadge);
                      }
                      var labelEl = p.querySelector('.cfg-pill__label');
                      var labelText = labelEl ? labelEl.textContent.trim() : p.getAttribute('data-personalization');
                      p.setAttribute('aria-label', labelText + ' personalization selected — click to remove');
                    } else {
                      if (xBadge) xBadge.remove();
                      // Drop the override so the pill's accessible name falls back to its
                      // visible label + price spans.
                      p.removeAttribute('aria-label');
                    }
                  });
                  // Active-flip swaps which pre-rendered sub-label span (.cfg-pill__price--
                  // inactive vs --active) is visible on each pill. Both spans live in the DOM
                  // already (Liquid-rendered in active market currency); JS only toggles hidden.
                  updatePillSubLabelVisibility();
                  // Tier change also updates the main price display so the running total
                  // (case + upgrade) reflects the new tier. Each (variant, tier) pair has a
                  // pre-rendered Liquid money string in CFG_DATA.variantPrices — JS just picks
                  // the right one. variantInput.value is the canonical current variant ID,
                  // but it can be empty on first paint / when a third-party app replaces the
                  // hidden input. Fall back to state.colorEntry.variantId (set by selectColor
                  // at L3065 — same source selectColor uses successfully at L3074).
                  var variantId = variantInput && variantInput.value;
                  if (!variantId && state.colorEntry && state.colorEntry.variantId) {
                    variantId = state.colorEntry.variantId;
                    cfgLog('[cfg-debug] selectPersonalization: variantInput.value empty, falling back to state.colorEntry.variantId =', variantId);
                  }
                  if (variantId) {
                    // Raw tier as-is: normalizeTierKey maps null → 'none' (base price, no fee).
                    updatePriceForVariantAndTier(variantId, type);
                  }
                  // Text mode shows the text panel; Image mode shows the image panel.
                  panelText.hidden  = !(type === 'Text');
                  panelImage.hidden = !(type === 'Image');
                  if (textOptions) textOptions.hidden = !(type === 'Text');

                  if (type === 'Text') {
                    propType.value = 'Text';
                    propType.disabled = false;
                    propText.value = textarea.value;
                    propText.disabled = propText.value.trim() === '';
                    propImage.value = '';
                    propImage.disabled = true;
                    if (propFont) {
                      propFont.value = state.fontName;
                      // Don't emit an empty Font property before a real font is picked.
                      propFont.disabled = (state.fontName === '');
                    }
                  } else if (type === 'Image') {
                    // Image mode
                    propType.value = 'Image';
                    propType.disabled = false;
                    textarea.value = '';
                    propText.value = '';
                    propText.disabled = true;
                    state.textContent = '';
                    if (state.customImageUrl) {
                      propImage.value = state.customImageUrl;
                      propImage.disabled = false;
                    } else {
                      propImage.disabled = true;
                    }
                    if (propFont) propFont.disabled = true;
                  } else {
                    // Deselected (null) — neutralize every form-facing input so nothing can
                    // submit, but do NOT clear content state: textContent, customImageUrl,
                    // customImageReady and presetDesignName survive in memory so re-selecting
                    // the same mode restores its panel with content intact.
                    propType.value = '';
                    propType.disabled = true;
                    propText.disabled = true;
                    propImage.disabled = true;
                    if (propFont) propFont.disabled = true;
                  }
                  // Visibility/value sync runs after the mode is set so getCurrentSize/Position read the right field.
                  syncSlidersVisibility();
                  syncSlidersValues();
                  scheduleRender();
                  refreshCasesTotal();
                }

                function showUploadPreview(url) {
                  state.customImageUrl = url;
                  // Upload success resolves the image-gate warning: clear the red border AND
                  // dismiss the banner immediately (don't wait out its 15s auto-hide).
                  if (uploadBtn) uploadBtn.classList.remove('cfg-input--error');
                  hideVisibleError();
                  uploadThumb.src = url;
                  uploadThumb.hidden = false;
                  uploadLbl.textContent = replaceLabel;
                  propImage.value = url;
                  propImage.disabled = false;
                  // Note: syncImageActionsVisibility() is also called from the polling success
                  // handler — we don't show the Remove button here because the image isn't yet
                  // processed and "Remove" while still processing would be confusing.
                }

                // Phase 1b.2: Cloudinary server-side background removal + 1-bit B&W silhouette threshold.
                // Replaces the previous @imgly browser-side pipeline — no OOM risk on mobile,
                // no 50MB library download, identical results everywhere.

                function buildBackgroundRemovalUrl(cloudinaryUrl) {
                  // Injects "e_background_removal/" after "/upload/" and forces .png for transparency.
                  if (typeof cloudinaryUrl !== 'string') return cloudinaryUrl;
                  var marker = '/upload/';
                  var idx = cloudinaryUrl.indexOf(marker);
                  if (idx === -1) return cloudinaryUrl;
                  var before = cloudinaryUrl.substring(0, idx + marker.length);
                  var after = cloudinaryUrl.substring(idx + marker.length);
                  after = after.replace(/\.(webp|jpg|jpeg|gif|bmp|tiff|tif)$/i, '.png');
                  // w_800,c_limit caps the processed image at 800px wide (won't upscale smaller).
                  // e_grayscale produces a laser-engraving-ready monochrome PNG with transparent bg —
                  // composited via globalCompositeOperation='multiply' onto the case canvas downstream.
                  return before + 'e_background_removal,e_grayscale,w_800,c_limit/' + after;
                }

                function pollForBackgroundRemovedImage(url, maxAttempts, delayMs) {
                  // Cloudinary returns 423 (or 503/504) while bg removal is processing.
                  // Poll with HEAD until 200, then resolve with the URL.
                  return new Promise(function (resolve, reject) {
                    var attempts = 0;
                    function tryFetch() {
                      attempts++;
                      fetch(url, { method: 'HEAD', cache: 'no-store' })
                        .then(function (response) {
                          if (response.ok) {
                            resolve(url);
                          } else if (response.status === 423 || response.status === 503 || response.status === 504) {
                            if (attempts >= maxAttempts) {
                              reject(new Error('Image processing took too long — please try again'));
                            } else {
                              setTimeout(tryFetch, delayMs);
                            }
                          } else {
                            reject(new Error('Background removal returned unexpected status: ' + response.status));
                          }
                        })
                        .catch(function (err) {
                          if (attempts >= maxAttempts) {
                            reject(err);
                          } else {
                            setTimeout(tryFetch, delayMs);
                          }
                        });
                    }
                    tryFetch();
                  });
                }

                function fetchImageAsDataUrl(url) {
                  return fetch(url, { cache: 'force-cache' })
                    .then(function (r) {
                      if (!r.ok) throw new Error('Failed to fetch processed image: ' + r.status);
                      return r.blob();
                    })
                    .then(function (blob) {
                      return new Promise(function (resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function () { resolve(reader.result); };
                        reader.onerror = function () { reject(new Error('Failed to read processed image blob')); };
                        reader.readAsDataURL(blob);
                      });
                    });
                }

                function processImageWithSmartThreshold(dataUrl) {
                  // Decide which pixels engrave by analyzing the bg-removed grayscale image.
                  //   1. Count transparent vs visible pixels.
                  //   2. If >=30% transparent → bg removal worked → dark pixels engrave.
                  //   3. If <30% transparent → bg removal failed (graphic design) → auto-detect:
                  //        mean luma < 128 (dark-bg image like album cover) → INVERT: light pixels engrave
                  //        mean luma >= 128 (light-bg image)               → standard: dark pixels engrave
                  // Output: pure black RGB with alpha encoding engraving intensity. Combined with
                  // the multiply blend in renderImageLayer, alpha 255 = strong engraving, 0 = no effect.
                  var ALPHA_VISIBILITY = 50;
                  var BG_REMOVED_THRESHOLD = 0.30;
                  var LUMA_BOUNDARY = 128;

                  return new Promise(function (resolve, reject) {
                    var img = new Image();
                    img.onload = function () {
                      try {
                        var w = img.naturalWidth;
                        var h = img.naturalHeight;
                        var canvas = document.createElement('canvas');
                        canvas.width = w;
                        canvas.height = h;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);

                        var imageData = ctx.getImageData(0, 0, w, h);
                        var data = imageData.data;
                        var pixelCount = data.length / 4;

                        // Pass 1: analyze
                        var visiblePixelCount = 0;
                        var visibleLumaSum = 0;
                        for (var i = 0; i < data.length; i += 4) {
                          var a = data[i + 3];
                          if (a >= ALPHA_VISIBILITY) {
                            visiblePixelCount++;
                            // Cloudinary returns grayscale (R == G == B); sample R as luma
                            visibleLumaSum += data[i];
                          }
                        }

                        if (visiblePixelCount === 0) {
                          ctx.putImageData(imageData, 0, 0);
                          resolve(canvas.toDataURL('image/png'));
                          return;
                        }

                        var meanLuma = visibleLumaSum / visiblePixelCount;
                        var transparentRatio = (pixelCount - visiblePixelCount) / pixelCount;
                        var bgRemovedWell = transparentRatio >= BG_REMOVED_THRESHOLD;
                        var invertMode = bgRemovedWell ? false : (meanLuma < LUMA_BOUNDARY);

                        cfgLog('[configurator] smart-threshold:',
                          'transparent=' + (transparentRatio * 100).toFixed(0) + '%,',
                          'mean luma=' + meanLuma.toFixed(0) + ',',
                          'bg removed well=' + bgRemovedWell + ',',
                          'invert=' + invertMode);

                        // Pass 2: per-pixel engraving intensity
                        for (var i = 0; i < data.length; i += 4) {
                          var a = data[i + 3];
                          if (a < ALPHA_VISIBILITY) {
                            data[i] = 0; data[i + 1] = 0; data[i + 2] = 0; data[i + 3] = 0;
                            continue;
                          }
                          var luma = data[i];
                          var engravingAlpha = invertMode ? luma : (255 - luma);
                          data[i] = 0; data[i + 1] = 0; data[i + 2] = 0; data[i + 3] = engravingAlpha;
                        }

                        ctx.putImageData(imageData, 0, 0);
                        resolve(canvas.toDataURL('image/png'));
                      } catch (err) {
                        reject(err);
                      }
                    };
                    img.onerror = function () { reject(new Error('Failed to load image for smart threshold')); };
                    img.src = dataUrl;
                  });
                }

                function processUploadedImageForPreview(cloudinaryUrl) {
                  state.imageProcessing = true;
                  state.imageProcessError = null;
                  // Flip ready=false at the START so re-uploads correctly hide sliders
                  // until the new image finishes processing.
                  state.customImageReady = false;
                  syncSlidersVisibility();
                  renderPreview();
                  // Loading shimmer — fires across both preview wrappers (mobile + desktop hero)
                  document.querySelectorAll('.cfg-mobile-preview, .hero-image-wrapper').forEach(function (el) {
                    el.classList.add('is-processing');
                  });

                  var startTime = Date.now();
                  var bgRemovalUrl = buildBackgroundRemovalUrl(cloudinaryUrl);
                  cfgLog('[configurator] requesting bg-removal:', bgRemovalUrl);

                  // 60 attempts × 1000ms = 60s hard timeout for Cloudinary AI bg removal
                  return pollForBackgroundRemovedImage(bgRemovalUrl, 60, 1000)
                    .then(function (readyUrl) {
                      var pollMs = Date.now() - startTime;
                      cfgLog('[configurator] bg removal ready in', pollMs, 'ms');
                      return fetchImageAsDataUrl(readyUrl);
                    })
                    .then(function (rawDataUrl) {
                      var processingStart = Date.now();
                      return processImageWithSmartThreshold(rawDataUrl).then(function (processedDataUrl) {
                        cfgLog('[configurator] smart-threshold applied in', Date.now() - processingStart, 'ms');
                        return processedDataUrl;
                      });
                    })
                    .then(function (processedDataUrl) {
                      // Alpha-trim pass: crop transparent edges so the visible content fills the
                      // renderer's bounding box. Operates on the smart-threshold data URL (whose
                      // alpha encodes engraving intensity — visible pixels >0, background ==0).
                      // The trim only affects state.imageProcessedDataUrl (preview-render state);
                      // state.customImageUrl + the `_Custom Image URL` cart property still carry
                      // the raw untrimmed Cloudinary URL for fulfillment.
                      return new Promise(function (resolve) {
                        var img = new Image();
                        img.onload = function () {
                          var trimStart = Date.now();
                          var trimmed = autoTrimAlpha(img, 10);
                          if (trimmed === img) {
                            cfgLog('[configurator] alpha-trim no-op (already tight, fully transparent, or load failure)');
                            resolve(processedDataUrl);
                          } else {
                            cfgLog('[configurator] alpha-trim',
                              (img.naturalWidth ?? img.width) + 'x' + (img.naturalHeight ?? img.height),
                              '->', trimmed.width + 'x' + trimmed.height,
                              'in', (Date.now() - trimStart) + 'ms');
                            resolve(trimmed.toDataURL('image/png'));
                          }
                        };
                        img.onerror = function () {
                          cfgWarn('[configurator] alpha-trim image load failed — using untrimmed data URL');
                          resolve(processedDataUrl);
                        };
                        img.src = processedDataUrl;
                      });
                    })
                    .then(function (finalDataUrl) {
                      state.imageProcessedDataUrl = finalDataUrl;
                      state.imageProcessing = false;
                      state.customImageReady = true;
                      var totalMs = Date.now() - startTime;
                      cfgLog('[configurator] image fully processed (bg removed + grayscale + smart threshold) in', totalMs, 'ms');
                      // Stop shimmer + start fade-in — image opacity goes from 0 → 1 over 300ms.
                      document.querySelectorAll('.cfg-mobile-preview, .hero-image-wrapper').forEach(function (el) {
                        el.classList.remove('is-processing');
                      });
                      state.imageOpacity = 0;
                      renderPreview();
                      var fadeStart = performance.now();
                      function fadeStep(now) {
                        var t = Math.min(1, (now - fadeStart) / 300);
                        state.imageOpacity = t;
                        scheduleRender();
                        if (t < 1) requestAnimationFrame(fadeStep);
                      }
                      requestAnimationFrame(fadeStep);
                      // Image is ready — reveal size + position sliders for Image mode
                      // and seed them with the current imageSize / imagePositionY values.
                      syncSlidersVisibility();
                      syncSlidersValues();
                      syncImageActionsVisibility();
                    })
                    .catch(function (err) {
                      console.error('[configurator] image processing failed:', err);
                      state.imageProcessing = false;
                      state.customImageReady = false;
                      state.imageProcessError = err.message || 'Image processing failed';
                      // Stop shimmer on failure too
                      document.querySelectorAll('.cfg-mobile-preview, .hero-image-wrapper').forEach(function (el) {
                        el.classList.remove('is-processing');
                      });
                      showVisibleError('Preview failed: ' + (err.message || 'Unknown error'));
                      renderPreview();
                      syncSlidersVisibility();
                    });
                }

                function openCloudinaryWidget() {
                  function open() {
                    window.cloudinary.createUploadWidget({
                      cloudName: cloudName,
                      uploadPreset: uploadPreset,
                      sources: ['local', 'url', 'camera'],
                      multiple: false,
                      maxFileSize: 10000000,
                      clientAllowedFormats: ['image'],
                      cropping: false,
                      showSkipCropButton: false,
                      maxImageWidth: 2000,
                      maxImageHeight: 2000
                    }, function (error, result) {
                      if (!error && result && result.event === 'success') {
                        // A real upload replaces any preset-design selection.
                        state.presetDesignName = null;
                        showUploadPreview(result.info.secure_url);
                        // Phase 1b: run background-removal on Cloudinary URL for preview compositing
                        processUploadedImageForPreview(result.info.secure_url);
                      }
                    }).open();
                  }
                  if (typeof window.cloudinary !== 'undefined' && window.cloudinary.createUploadWidget) {
                    open();
                  } else {
                    var tries = 0;
                    var iv = setInterval(function () {
                      tries++;
                      if (typeof window.cloudinary !== 'undefined' && window.cloudinary.createUploadWidget) {
                        clearInterval(iv);
                        open();
                      } else if (tries > 40) {
                        clearInterval(iv);
                        cfgWarn('[configurator] Cloudinary widget never became available');
                        showVisibleError('Image uploader could not be loaded. Please refresh and try again.');
                      }
                    }, 150);
                  }
                }

                // Font cart-gate UI (Change 4). Mirrors the removed WhatsApp-error pattern:
                // red border on the dropdown trigger + an inline .cfg-error-msg + scroll-to.
                function showFontError() {
                  if (fontDropdown) {
                    var trig = fontDropdown.querySelector('.cfg-dropdown__trigger');
                    if (trig) trig.classList.add('cfg-input--error');
                  }
                  if (fontError) fontError.hidden = false;
                  var target = fontDropdown || fontError;
                  if (target) {
                    try {
                      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    } catch (err) {
                      target.scrollIntoView();
                    }
                  }
                  cfgLog('[configurator] font not selected - blocked submit');
                }

                function clearFontError() {
                  if (fontDropdown) {
                    var trig = fontDropdown.querySelector('.cfg-dropdown__trigger');
                    if (trig) trig.classList.remove('cfg-input--error');
                  }
                  if (fontError) fontError.hidden = true;
                }

                // Empty-text cart-gate UI. Mirrors the font-gate pattern above:
                // red border on the textarea + an inline .cfg-text-error + scroll-to.
                function showTextError() {
                  if (textarea) textarea.classList.add('cfg-input--error');
                  if (textError) textError.hidden = false;
                  var target = textarea ?? textError;
                  if (target) {
                    try {
                      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    } catch (err) {
                      target.scrollIntoView();
                    }
                  }
                  cfgLog('[configurator] text empty - blocked submit');
                }

                function clearTextError() {
                  if (textarea) textarea.classList.remove('cfg-input--error');
                  if (textError) textError.hidden = true;
                }

                trigger.addEventListener('click', function (e) {
                  e.stopPropagation();
                  toggleDropdown();
                });

                trigger.addEventListener('keydown', function (e) {
                  if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openDropdown();
                    setTimeout(function () { menu.focus && menu.focus(); }, 0);
                  } else if (e.key === 'Escape') {
                    closeDropdown();
                  }
                });

                menu.addEventListener('keydown', function (e) {
                  if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    if (highlightedIndex < sortedModels.length - 1) highlightedIndex++;
                    updateHighlight();
                  } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    if (highlightedIndex > 0) highlightedIndex--;
                    updateHighlight();
                  } else if (e.key === 'Enter') {
                    e.preventDefault();
                    if (highlightedIndex >= 0) {
                      selectModel(sortedModels[highlightedIndex]);
                      closeDropdown();
                      trigger.focus();
                    }
                  } else if (e.key === 'Escape') {
                    e.preventDefault();
                    closeDropdown();
                    trigger.focus();
                  }
                });

                document.addEventListener('click', function (e) {
                  if (!dropdown.contains(e.target)) closeDropdown();
                });

                pills.forEach(function (p) {
                  p.addEventListener('click', function () {
                    var mode = p.getAttribute('data-personalization');
                    // Toggle-off: clicking the already-active pill deselects (null mode).
                    // Content state is retained; re-selecting restores the panel intact.
                    selectPersonalization(mode === state.personalization ? null : mode);
                  });
                });

                var textCounter = root.querySelector('[data-cfg-text-counter]');
                if (textarea) {
                  textarea.addEventListener('input', function () {
                    // Enforce character limit BEFORE downstream consumers read .value.
                    var limit = getCurrentCharLimit();
                    if (textarea.value.length > limit) {
                      textarea.value = textarea.value.substring(0, limit);
                    }
                    state.textContent = textarea.value;
                    clearTextError();
                    if (state.personalization === 'Text') {
                      propText.value = textarea.value;
                      propText.disabled = textarea.value.trim() === '';
                    }
                    updateCharCounter(textarea, textCounter);
                    autoResizeTextarea(textarea);
                    scheduleRender();
                  });
                  // Initial sizing + counter for any pre-filled content.
                  autoResizeTextarea(textarea);
                  updateCharCounter(textarea, textCounter);
                } else {
                  cfgWarn('[configurator] textarea not found - text input disabled');
                }

                // Reusable custom-dropdown wiring (mirrors the model picker). A native <select>
                // renders option text with the OS font, so per-option font-family never shows —
                // this builds a real listbox where each <li> displays in its own face. onSelect
                // gets (family, name) when a font is chosen (click / Enter).
                function wireFontDropdown(dd, onSelect) {
                  if (!dd) return false;
                  var ddTrigger = dd.querySelector('.cfg-dropdown__trigger');
                  var ddLabel   = dd.querySelector('.cfg-dropdown__label');
                  var ddMenu    = dd.querySelector('.cfg-dropdown__menu');
                  if (!ddTrigger || !ddMenu) return false;
                  var ddItems = Array.prototype.slice.call(ddMenu.querySelectorAll('.cfg-dropdown__item'));
                  if (!ddItems.length) return false;
                  var hi = -1;
                  function highlight() {
                    ddItems.forEach(function (it, idx) { it.classList.toggle('is-highlight', idx === hi); });
                    if (hi >= 0 && ddItems[hi]) ddItems[hi].scrollIntoView({ block: 'nearest' });
                  }
                  function open() {
                    dd.classList.add('is-open');
                    ddTrigger.setAttribute('aria-expanded', 'true');
                    hi = 0;
                    for (var i = 0; i < ddItems.length; i++) {
                      if (ddItems[i].getAttribute('aria-selected') === 'true') { hi = i; break; }
                    }
                    highlight();
                  }
                  function close() {
                    dd.classList.remove('is-open');
                    ddTrigger.setAttribute('aria-expanded', 'false');
                  }
                  function choose(it) {
                    var family = it.getAttribute('data-font-family');
                    var name   = it.getAttribute('data-font-name');
                    ddItems.forEach(function (o) { o.setAttribute('aria-selected', o === it ? 'true' : 'false'); });
                    if (ddLabel) { ddLabel.textContent = name; ddLabel.style.fontFamily = family; ddLabel.classList.remove('cfg-dropdown__label--placeholder'); }
                    onSelect(family, name);
                  }
                  ddItems.forEach(function (it, idx) {
                    it.addEventListener('click', function (e) { e.stopPropagation(); choose(it); close(); ddTrigger.focus(); });
                    it.addEventListener('mouseenter', function () { hi = idx; highlight(); });
                  });
                  ddTrigger.addEventListener('click', function (e) {
                    e.stopPropagation();
                    if (dd.classList.contains('is-open')) close(); else open();
                  });
                  ddTrigger.addEventListener('keydown', function (e) {
                    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); open(); setTimeout(function () { ddMenu.focus && ddMenu.focus(); }, 0);
                    } else if (e.key === 'Escape') { close(); }
                  });
                  ddMenu.addEventListener('keydown', function (e) {
                    if (e.key === 'ArrowDown') { e.preventDefault(); if (hi < ddItems.length - 1) hi++; highlight(); }
                    else if (e.key === 'ArrowUp') { e.preventDefault(); if (hi > 0) hi--; highlight(); }
                    else if (e.key === 'Enter') { e.preventDefault(); if (hi >= 0) { choose(ddItems[hi]); close(); ddTrigger.focus(); } }
                    else if (e.key === 'Escape') { e.preventDefault(); close(); ddTrigger.focus(); }
                  });
                  document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
                  return true;
                }

                // Explicitly load a webfont family before drawing the canvas, then re-render —
                // otherwise a not-yet-loaded face renders as a silent fallback. Quote the family
                // so multi-word names (e.g. "Cormorant Garamond") parse in the font shorthand.
                function loadFontThenRender(family) {
                  try {
                    if (document.fonts && document.fonts.load && family) {
                      document.fonts.load('1em "' + family + '"').then(scheduleRender, scheduleRender);
                    }
                  } catch (e) { /* ignore font-shorthand parse issues; render below still runs */ }
                }

                if (fontDropdown) {
                  wireFontDropdown(fontDropdown, function (family, name) {
                    state.fontFamily = family;
                    state.fontName   = name;
                    clearFontError();
                    if (propFont && state.personalization === 'Text') { propFont.value = state.fontName; propFont.disabled = false; }
                    // New font may have a stricter char limit — truncate existing text + refresh counter.
                    var limit = getCurrentCharLimit();
                    if (textarea && textarea.value.length > limit) {
                      textarea.value = textarea.value.substring(0, limit);
                      state.textContent = textarea.value;
                      if (propText && state.personalization === 'Text') {
                        propText.value = textarea.value;
                        propText.disabled = textarea.value.trim() === '';
                      }
                    }
                    updateCharCounter(textarea, textCounter);
                    loadFontThenRender(family);
                    scheduleRender();
                  });
                } else {
                  cfgWarn('[configurator] font dropdown not found - font picker disabled');
                }

                if (sizeSliders.length === 0) {
                  cfgWarn('[configurator] no size slider found');
                } else {
                  cfgLog('[configurator] size sliders attached:', sizeSliders.length);
                  sizeSliders.forEach(function (slider) {
                    slider.addEventListener('input', function (e) {
                      var newVal = parseInt(e.target.value, 10);
                      // Mode-aware: writes to imageSize in Image mode, sizeScale in Text mode.
                      setCurrentSize(newVal);
                      sizeSliders.forEach(function (s) { if (s !== e.target) s.value = newVal; });
                      document.querySelectorAll('.cfg-size__value').forEach(function (v) {
                        v.textContent = newVal + '%';
                      });
                      if (typeof updateSliderAria === 'function') updateSliderAria();
                      scheduleRender();
                    });
                  });
                }

                if (positionSliders.length > 0) {
                  cfgLog('[configurator] position sliders attached:', positionSliders.length);
                  // Snap-to-center: subtle stickiness around 50% so customers can find true
                  // center without overshoot. Position-only — size 50% isn't a meaningful target.
                  var POSITION_SNAP_TARGET = 50;
                  var POSITION_SNAP_THRESHOLD = 3;
                  positionSliders.forEach(function (slider) {
                    slider.addEventListener('input', function (e) {
                      var newVal = parseInt(e.target.value, 10);
                      if (newVal >= POSITION_SNAP_TARGET - POSITION_SNAP_THRESHOLD &&
                          newVal <= POSITION_SNAP_TARGET + POSITION_SNAP_THRESHOLD &&
                          newVal !== POSITION_SNAP_TARGET) {
                        newVal = POSITION_SNAP_TARGET;
                        e.target.value = newVal;
                      }
                      // Mode-aware: writes to imagePositionY in Image mode, textPositionY in Text mode.
                      setCurrentPosition(newVal);
                      // Sync sibling sliders (mobile + desktop instances stay in lockstep)
                      positionSliders.forEach(function (s) { if (s !== e.target) s.value = newVal; });
                      document.querySelectorAll('[data-cfg-position-y-display]').forEach(function (d) {
                        d.textContent = newVal + '%';
                      });
                      if (typeof updateSliderAria === 'function') updateSliderAria();
                      scheduleRender();
                    });
                  });
                }

                // Drag-and-drop on the upload zone (.cfg-upload__btn is the <label> wrapping the file input).
                // Reuses the existing UPLOAD_MAX_BYTES + UPLOAD_ALLOWED_MIME/EXT validation that the
                // file-picker change handler already runs, by handing off the dropped file via DataTransfer.
                if (uploadBtn && mobileFileInput) {
                  ['dragenter', 'dragover'].forEach(function (evt) {
                    uploadBtn.addEventListener(evt, function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      uploadBtn.classList.add('is-dragover');
                    });
                  });
                  ['dragleave', 'drop'].forEach(function (evt) {
                    uploadBtn.addEventListener(evt, function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      uploadBtn.classList.remove('is-dragover');
                    });
                  });
                  uploadBtn.addEventListener('drop', function (e) {
                    e.preventDefault();
                    var files = e.dataTransfer && e.dataTransfer.files;
                    if (!files || files.length === 0) return;
                    var file = files[0];
                    // Inline validation — mirrors the file-change handler's checks so dropped
                    // files get the same friendly errors before any Cloudinary work.
                    if (file.size > UPLOAD_MAX_BYTES) {
                      showVisibleError('Image too large. Please choose a file under 10MB.');
                      return;
                    }
                    var mimeOk = UPLOAD_ALLOWED_MIME.test(file.type || '');
                    var extOk  = UPLOAD_ALLOWED_EXT.test(file.name || '');
                    if (!mimeOk && !extOk) {
                      showVisibleError('Unsupported file type. Please upload a PNG, JPG, WebP, or HEIC image.');
                      return;
                    }
                    // Hand off to the existing upload pipeline via the file input's change event.
                    try {
                      var dt = new DataTransfer();
                      dt.items.add(file);
                      mobileFileInput.files = dt.files;
                      mobileFileInput.dispatchEvent(new Event('change', { bubbles: true }));
                    } catch (err) {
                      console.error('[configurator] drop handoff failed:', err);
                      showVisibleError('Could not accept the dropped file. Please tap Upload Image instead.');
                    }
                  });
                  // Document-level drop prevention — stops the browser from opening the file
                  // as a new tab if the customer misses the drop zone. The drop zone itself
                  // continues to handle drops normally because we early-return on its targets.
                  ['dragover', 'drop'].forEach(function (evt) {
                    document.addEventListener(evt, function (e) {
                      if (e.target.closest && e.target.closest('.cfg-upload__btn')) return;
                      e.preventDefault();
                    });
                  });
                }

                // Remove image button — wipes processed/raw image state, resets size/position to defaults,
                // allows the same file to be re-uploaded (file input value reset).
                document.querySelectorAll('[data-cfg-remove-image]').forEach(function (btn) {
                  btn.addEventListener('click', function () {
                    // Content change never (re)creates a warning — only an ATC attempt does.
                    // Dismiss any lingering gate banner so it can't outlive the state it warned about.
                    hideVisibleError();
                    // Removing the image also discards any preset-design selection it came from.
                    state.presetDesignName = null;
                    state.customImageReady = false;
                    state.imageProcessedDataUrl = null;
                    state.imageProcessError = null;
                    // Reset fade-in state so the next upload starts cleanly at opacity 0 → 1.
                    state.imageOpacity = 1;
                    state.customImageUrl = null;
                    state.imageSize = 100;
                    state.imagePositionY = 50;
                    // Cart property cleanup — propImage holds the raw upload URL.
                    if (propImage) {
                      propImage.value = '';
                      propImage.disabled = true;
                    }
                    // Reset thumb + label + file input
                    if (uploadThumb) {
                      uploadThumb.removeAttribute('src');
                      uploadThumb.hidden = true;
                    }
                    if (uploadLbl) uploadLbl.textContent = data.uploadLabel;
                    document.querySelectorAll('[data-cfg-image-upload]').forEach(function (input) {
                      input.value = '';
                    });
                    syncImageActionsVisibility();
                    scheduleRender();
                    syncSlidersVisibility();
                    syncSlidersValues();
                  });
                });

                // Image-actions visibility: when customImageReady, show Remove + flip label to Replace.
                // When not ready, hide Remove (the existing Choose-image label remains as the only action).
                function syncImageActionsVisibility() {
                  document.querySelectorAll('[data-cfg-remove-image]').forEach(function (btn) {
                    btn.hidden = !state.customImageReady;
                  });
                }

                function isMobileViewport() {
                  return window.matchMedia('(max-width: 767px)').matches;
                }

                uploadBtn.addEventListener('click', function (e) {
                  if (!isMobileViewport()) {
                    // Desktop: intercept the label's native file-input trigger, open Cloudinary widget instead
                    e.preventDefault();
                    openCloudinaryWidget();
                  }
                  // Mobile: do absolutely nothing. The <label for="…"> native browser behavior
                  // dispatches the click to the file input, which opens the iOS picker.
                  // Any DOM manipulation here can break that chain on iOS Safari.
                });

                mobileFileInput.addEventListener('change', function (e) {
                  cfgLog('[configurator] mobile file input change event fired');
                  var file = e.target.files && e.target.files[0];
                  if (!file) {
                    cfgWarn('[configurator] mobile change event but no file selected');
                    return;
                  }
                  cfgLog('[configurator] mobile file selected:', file.name, file.size, file.type);
                  // Pre-validation BEFORE async work — fail fast with friendly messages.
                  if (file.size > UPLOAD_MAX_BYTES) {
                    showVisibleError('Image too large. Please choose a file under 10MB.');
                    mobileFileInput.value = '';
                    return;
                  }
                  // Some iOS HEIC files report empty MIME but have a .heic extension; accept either signal.
                  var mimeOk = UPLOAD_ALLOWED_MIME.test(file.type || '');
                  var extOk  = UPLOAD_ALLOWED_EXT.test(file.name || '');
                  if (!mimeOk && !extOk) {
                    showVisibleError('Unsupported file type. Please upload a PNG, JPG, WebP, or HEIC image.');
                    mobileFileInput.value = '';
                    return;
                  }
                  var originalLabel = uploadLbl.textContent;
                  uploadLbl.textContent = 'Uploading...';
                  uploadBtn.disabled = true;
                  var formData = new FormData();
                  formData.append('file', file);
                  formData.append('upload_preset', uploadPreset);
                  cfgLog('[configurator] mobile upload starting to Cloudinary cloud=' + cloudName + ' preset=' + uploadPreset);
                  fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', {
                    method: 'POST',
                    body: formData
                  })
                    .then(function (res) {
                      cfgLog('[configurator] mobile Cloudinary HTTP status:', res.status);
                      return res.json();
                    })
                    .then(function (uploadResult) {
                      if (!uploadResult || !uploadResult.secure_url) {
                        console.error('[configurator] mobile Cloudinary response missing secure_url:', uploadResult);
                        showVisibleError('Cloudinary returned no image URL. Response: ' + JSON.stringify(uploadResult).substring(0, 200));
                        uploadLbl.textContent = originalLabel;
                        return;
                      }
                      cfgLog('[configurator] mobile upload success, secure_url:', uploadResult.secure_url);
                      // A real upload replaces any preset-design selection (same as the widget path).
                      state.presetDesignName = null;
                      // 1. Cart-property + UI thumbnail (preserves laser-file path)
                      showUploadPreview(uploadResult.secure_url);
                      // 2. Kick off Cloudinary server-side bg-removal + dithering for the on-case preview
                      cfgLog('[configurator] mobile calling processUploadedImageForPreview with URL');
                      processUploadedImageForPreview(uploadResult.secure_url);
                    })
                    .catch(function (err) {
                      console.error('[configurator] mobile upload failed:', err);
                      showVisibleError('Upload failed: ' + (err.message || 'Unknown error') + '. Tap Upload Image to retry.');
                      uploadLbl.textContent = originalLabel;
                      mobileFileInput.value = '';
                    })
                    .finally(function () {
                      uploadBtn.disabled = false;
                      mobileFileInput.value = '';
                    });
                });

                if (noteInput) {
                  noteInput.addEventListener('input', function () {
                    state.customerNote = noteInput.value ?? '';
                  });
                }

                function renderEngravingText(ctx, canvas) {
                  // Mode gate (defense-in-depth): engraving text exists only for Text/Combined
                  // cases — retained-but-deselected text must never reach the laser PNG,
                  // regardless of call site.
                  if (state.personalization !== 'Text' && state.personalization !== 'Combined') return;
                  // Same fill-factor math as renderTextLayer so the captured PNG matches the live preview.
                  // The entire engraving canvas IS the text area (no offsets).
                  var text = (state.textContent || '').trim();
                  if (!text) return;
                  var lines = text.split('\n').filter(function (l) { return l.trim(); });
                  if (lines.length === 0) return;

                  var clampedSlider = Math.max(0, Math.min(100, state.sizeScale));
                  var fillFactor = 0.10 + (clampedSlider / 100) * 0.80;
                  var availableHeight = canvas.height * fillFactor;
                  var availableWidth = canvas.width * fillFactor;
                  var lineHeightFactor = 1.0;
                  // Mirror the renderTextLayer per-font multiplier so the captured engraving PNG
                  // matches what the customer sees in the live preview.
                  var fontSize = ((availableHeight / lines.length) / lineHeightFactor) * getCurrentSizeMultiplier();
                  ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);

                  // Step 1: Compensate for font metric padding using actual glyph bounds.
                  // EM box (fontSize) includes empty ascender/descender space; visible glyphs are ~60-75% of it.
                  // Per-line worst-case scale — EXACT mirror of renderTextLayer's Step 1 so the
                  // laser-ready PNG matches the live preview. Single line: identical to before.
                  try {
                    var scriptFontNames = ['Pinyon Script', 'Great Vibes', 'Allura', 'Italianno', 'Dancing Script', 'Ballet'];
                    var currentFontFamily = state.fontFamily || '';
                    var isScriptFont = scriptFontNames.some(function (name) {
                      return currentFontFamily.indexOf(name) !== -1;
                    });
                    // Font-specific compensation factor:
                    //   Script fonts (Pinyon Script, etc.) — decorative width works at 0.85
                    //   Sans-serif (Montserrat, Helvetica) — tight bounds; 0.85 overshoots, use 0.70
                    var compensationMultiplier = isScriptFont ? 0.85 : 0.70;
                    var worstScale = null;
                    for (var li = 0; li < lines.length; li++) {
                      var sampleMetrics = ctx.measureText(lines[li]);
                      if (sampleMetrics.actualBoundingBoxAscent === undefined ||
                          sampleMetrics.actualBoundingBoxDescent === undefined) continue;
                      var actualGlyphHeight = sampleMetrics.actualBoundingBoxAscent + sampleMetrics.actualBoundingBoxDescent;
                      var lineScale = (actualGlyphHeight > 0 && actualGlyphHeight < fontSize)
                        ? (fontSize / actualGlyphHeight) * compensationMultiplier
                        : 1.0;
                      if (worstScale === null || lineScale < worstScale) worstScale = lineScale;
                    }
                    if (worstScale !== null && worstScale !== 1.0) {
                      fontSize = fontSize * worstScale;
                      ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                    }
                  } catch (e) {
                    cfgWarn('[configurator] actualBoundingBox metrics unavailable, using EM box sizing');
                  }

                  // Step 2: Width constraint — shrink font further if the widest line exceeds available width
                  var widestLine = 0;
                  for (var i = 0; i < lines.length; i++) {
                    var metrics = ctx.measureText(lines[i]);
                    // Use actual visible bounding box width when available — captures script-font flourishes
                    // that advance width (.width) misses. Fall back to .width on older browsers.
                    var visibleWidth = metrics.width;
                    if (typeof metrics.actualBoundingBoxLeft === 'number' &&
                        typeof metrics.actualBoundingBoxRight === 'number') {
                      var bboxWidth = Math.abs(metrics.actualBoundingBoxLeft) + metrics.actualBoundingBoxRight;
                      // Use the larger of advance width vs visible bbox — whichever is more conservative
                      if (bboxWidth > visibleWidth) visibleWidth = bboxWidth;
                    }
                    if (visibleWidth > widestLine) widestLine = visibleWidth;
                  }
                  if (widestLine > availableWidth) {
                    fontSize = fontSize * (availableWidth / widestLine);
                    ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                  }

                  ctx.fillStyle = '#000';
                  ctx.textBaseline = 'middle';
                  ctx.textAlign = 'center';
                  var lineHeight = fontSize * lineHeightFactor;
                  var totalTextHeight = lineHeight * lines.length;

                  // Ink-block metrics + containment + ink-centering — EXACT mirror of
                  // renderTextLayer (the engraving canvas IS the area: x/y = 0, w/h = canvas).
                  var lineMetrics = [];
                  var inkTopRel = Infinity, inkBottomRel = -Infinity, inkWidest = 0;
                  try {
                    for (var li2 = 0; li2 < lines.length; li2++) {
                      var lm = ctx.measureText(lines[li2]);
                      var entry = { offsetX: 0 };
                      if (typeof lm.actualBoundingBoxLeft === 'number' &&
                          typeof lm.actualBoundingBoxRight === 'number') {
                        entry.offsetX = (lm.actualBoundingBoxRight - lm.actualBoundingBoxLeft) / 2;
                        var inkW = Math.abs(lm.actualBoundingBoxLeft) + lm.actualBoundingBoxRight;
                        if (inkW > inkWidest) inkWidest = inkW;
                      }
                      if (lm.actualBoundingBoxAscent !== undefined &&
                          lm.actualBoundingBoxDescent !== undefined) {
                        var topRel = li2 * lineHeight - lm.actualBoundingBoxAscent;
                        var botRel = li2 * lineHeight + lm.actualBoundingBoxDescent;
                        if (topRel < inkTopRel) inkTopRel = topRel;
                        if (botRel > inkBottomRel) inkBottomRel = botRel;
                      }
                      lineMetrics.push(entry);
                    }
                  } catch (e2) {
                    inkTopRel = Infinity; inkBottomRel = -Infinity;
                  }
                  var inkMetricsOk = isFinite(inkTopRel) && isFinite(inkBottomRel);

                  if (inkMetricsOk) {
                    var blockH = inkBottomRel - inkTopRel;
                    var containScale = 1;
                    if (blockH > canvas.height) containScale = canvas.height / blockH;
                    if (inkWidest > canvas.width) containScale = Math.min(containScale, canvas.width / inkWidest);
                    if (containScale < 1) {
                      fontSize = fontSize * containScale;
                      ctx.font = fontSize + 'px ' + (state.fontFamily || defaultFontFamily);
                      lineHeight = fontSize * lineHeightFactor;
                      totalTextHeight = lineHeight * lines.length;
                      inkTopRel *= containScale;
                      inkBottomRel *= containScale;
                      for (var li3 = 0; li3 < lineMetrics.length; li3++) {
                        lineMetrics[li3].offsetX *= containScale;
                      }
                    }
                  }

                  // Match renderTextLayer position math so engraving PNG mirrors live preview.
                  var positionRatio = (state.textPositionY ?? 50) / 100;
                  var verticalSpace = Math.max(0, canvas.height - totalTextHeight);
                  var startY = (lineHeight / 2) + (positionRatio * verticalSpace);
                  if (inkMetricsOk) {
                    if (verticalSpace === 0) {
                      var inkRoom = Math.max(0, canvas.height - (inkBottomRel - inkTopRel));
                      startY = (0 - inkTopRel) + (positionRatio * inkRoom);
                    } else {
                      var spillBottom = (startY + inkBottomRel) - canvas.height;
                      if (spillBottom > 0) startY -= spillBottom;
                      var spillTop = 0 - (startY + inkTopRel);
                      if (spillTop > 0) startY += spillTop;
                    }
                  }
                  var centerX = canvas.width / 2;
                  for (var j = 0; j < lines.length; j++) {
                    var drawOffsetX = lineMetrics[j] ? lineMetrics[j].offsetX : 0;
                    ctx.fillText(lines[j], centerX - drawOffsetX, startY + j * lineHeight);
                  }
                }

                function restoreSubmitButton(btn, originalText) {
                  if (!btn) return;
                  btn.disabled = false;
                  if (typeof originalText === 'string') btn.textContent = originalText;
                }

                // Wait for an in-flight bg-removal pass to finish so the mockup capture doesn't
                // snapshot the "Processing image..." placeholder. Resolves true on clean finish,
                // false on timeout (caller decides whether to proceed with whatever's on the canvas).
                function waitForImageProcessing(timeoutMs) {
                  return new Promise(function (resolve) {
                    if (!state.imageProcessing) { resolve(true); return; }
                    var startedAt = Date.now();
                    var iv = setInterval(function () {
                      if (!state.imageProcessing) {
                        clearInterval(iv);
                        resolve(true);
                      } else if (Date.now() - startedAt > timeoutMs) {
                        clearInterval(iv);
                        resolve(false);
                      }
                    }, 200);
                  });
                }

                // Render the full case-with-personalization composite into an arbitrary canvas
                // WITHOUT resetting its dimensions (unlike renderToCanvas, which forces canvas
                // size to sourceImage.naturalWidth/Height). Used by the high-res mockup capture.
                function renderCompositeInto(ctx, canvas) {
                  if (!sourceImage) return;
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  ctx.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
                  if (state.personalization === 'Text' && state.textContent && state.textContent.trim()) {
                    renderTextLayer(ctx, canvas);
                  } else if (state.personalization === 'Image') {
                    renderImageLayer(ctx, canvas);
                  }
                }

                // Strengthened mockup capture: renders fresh into an offscreen canvas at >= 800px wide
                // (or scaleFactor × source, whichever is larger). Avoids stale-canvas concerns and
                // guarantees a QA-inspectable resolution.
                function captureCaseMockup(scaleFactor) {
                  scaleFactor = scaleFactor || 1;
                  return new Promise(function (resolve, reject) {
                    if (!sourceImage) {
                      reject(new Error('No source image available for mockup'));
                      return;
                    }
                    var srcW = sourceImage.naturalWidth;
                    var srcH = sourceImage.naturalHeight;
                    if (!srcW || !srcH) {
                      reject(new Error('Source image not loaded'));
                      return;
                    }
                    // Force minimum 800px wide for QA inspection.
                    var MOCKUP_MAX = 1600;                                  // cap longest side -> keeps PNG under Cloudinary's 10 MB limit
                    var srcLongest = Math.max(srcW, srcH);
                    var minScale = Math.min(scaleFactor, MOCKUP_MAX / srcLongest);
                    if (srcW * minScale < 800) minScale = 800 / srcW;       // keep a sensible minimum width
                    var off = document.createElement('canvas');
                    off.width  = Math.round(srcW * minScale);
                    off.height = Math.round(srcH * minScale);
                    var ctx = off.getContext('2d');
                    renderCompositeInto(ctx, off);
                    off.toBlob(function (blob) {
                      if (!blob) {
                        reject(new Error('Failed to capture case mockup blob'));
                        return;
                      }
                      var formData = new FormData();
                      formData.append('file', blob, 'mockup.png');
                      formData.append('upload_preset', uploadPreset);
                      fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', {
                        method: 'POST',
                        body: formData
                      })
                        .then(function (r) {
                          if (!r.ok) throw new Error('Cloudinary mockup upload failed: ' + r.status);
                          return r.json();
                        })
                        .then(function (result) {
                          if (!result || !result.secure_url) throw new Error('Cloudinary returned no secure_url for mockup');
                          resolve(result.secure_url);
                        })
                        .catch(reject);
                    }, 'image/png');
                  });
                }

                // Returns a promise that resolves once the case mockup PNG has been uploaded and
                // the hidden _Order Preview input has been set. Does NOT submit the cart — the
                // submit handler orchestrates that AFTER all decorators have resolved. Waits up
                // to 10s for any in-flight Cloudinary bg-removal to clear so the captured mockup
                // doesn't snapshot the "Processing image..." placeholder.
                function captureMockupProperty() {
                  cfgLog('[velvetshieldz] captureMockupProperty start');
                  return waitForImageProcessing(10000)
                    .then(function (cleanFinish) {
                      if (!cleanFinish) {
                        cfgWarn('[configurator] image processing did not finish within 10s — capturing whatever is on the canvas');
                      }
                      return captureCaseMockup(2);
                    })
                    .then(function (mockupUrl) {
                      if (propMockup) {
                        propMockup.value = mockupUrl;
                        propMockup.disabled = false;
                      }
                      cfgLog('[configurator] mockup uploaded:', mockupUrl);
                    });
                }

                // Build + POST both line items in a single /cart/add.js request. The case keeps
                // every existing property (Personalization Type, Custom Text, Font, Note,
                // _Engraving Image, _Custom Image URL, _Order Preview)
                // and gains "_Linked Group: <unique id>". The upgrade item carries only the
                // same _Linked Group so fulfillment can correlate the two lines. Graceful
                // degradation: when getCurrentUpgrade() returns null (fetch failed), submit
                // case-only — customer still completes purchase.
                // ============================================================================
                // MULTI-CASE CART (Stage 5) — build one set of line items PER design in designs[],
                // not just the active case. Each case is walked through loadDesign(i) so its own
                // state + images are live, then its engraving/mockup/wallet are captured. The whole
                // loop runs behind a freeze overlay (no visible cycling) and the original active
                // case is restored on any failure.
                // ============================================================================

                // Full-viewport "Preparing your order…" overlay so the customer never sees the
                // configurator cycle through cases while we capture each one. Built in JS (no Liquid
                // edit); respects prefers-reduced-motion (no spinner animation).
                var captureOverlayEl = null;
                function showCaptureOverlay() {
                  if (captureOverlayEl) { captureOverlayEl.hidden = false; return; }
                  if (!document.getElementById('cfg-capture-overlay-style')) {
                    var st = document.createElement('style');
                    st.id = 'cfg-capture-overlay-style';
                    st.textContent = '@keyframes cfgCaptureSpin{to{transform:rotate(360deg)}}';
                    document.head.appendChild(st);
                  }
                  var ov = document.createElement('div');
                  ov.setAttribute('role', 'status');
                  ov.setAttribute('aria-live', 'polite');
                  ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;background:rgba(255,255,255,0.94);font-family:inherit;color:#1a1a1a;';
                  var sp = document.createElement('div');
                  if (!prefersReducedMotion) {
                    sp.style.cssText = 'width:34px;height:34px;border:3px solid rgba(0,0,0,0.15);border-top-color:#1a1a1a;border-radius:50%;animation:cfgCaptureSpin 0.8s linear infinite;';
                  }
                  var msg = document.createElement('div');
                  msg.textContent = 'Preparing your order…';
                  msg.style.cssText = 'font-size:15px;font-weight:500;letter-spacing:-0.01em;';
                  ov.appendChild(sp); ov.appendChild(msg);
                  document.body.appendChild(ov);
                  captureOverlayEl = ov;
                }
                function hideCaptureOverlay() {
                  if (captureOverlayEl) { captureOverlayEl.remove(); captureOverlayEl = null; }
                }

                // Promise-based readiness for ONE design's composite assets — resolves only once
                // the actual font faces are loaded and the exact image URLs this design draws are
                // decoded. NOT a fixed timeout: document.fonts.load() settles on real font load,
                // and each Image resolves on its own onload. Captures additionally self-guard
                // (captureCaseMockup rejects on a zero-width source) so a not-ready asset ABORTS the
                // add-to-cart rather than uploading a blank engraving.
                function awaitDesignAssetsReady(d) {
                  var promises = [];
                  if (document.fonts && document.fonts.load) {
                    if (d.fontFamily) promises.push(document.fonts.load('1em "' + d.fontFamily + '"').catch(function () {}));
                    if (d.walletEnabled && d.walletFontFamily) promises.push(document.fonts.load('1em "' + d.walletFontFamily + '"').catch(function () {}));
                  }
                  var urls = [];
                  if (d.colorEntry && d.colorEntry.image) urls.push(d.colorEntry.image);
                  if (d.personalization === 'Image' && d.imageProcessedDataUrl) urls.push(d.imageProcessedDataUrl);
                  if (d.walletEnabled) {
                    var we = (d.colorEntry && data.walletMap) ? data.walletMap[d.colorEntry.colorName] : null;
                    if (we && we.previewImage) urls.push(we.previewImage);
                    if (d.walletPersonalization === 'Image' && d.walletProcessedDataUrl) urls.push(d.walletProcessedDataUrl);
                  }
                  urls.forEach(function (u) {
                    promises.push(new Promise(function (res) {
                      var im = new Image(); im.crossOrigin = 'anonymous';
                      im.onload = function () { res(); }; im.onerror = function () { res(); };
                      im.src = u;
                    }));
                  });
                  if (document.fonts && document.fonts.ready) promises.push(document.fonts.ready.catch(function () {}));
                  return Promise.all(promises);
                }

                // Render the active state's engraving offscreen, upload, and RESOLVE WITH the URL
                // (used per design while looping). Waits on document.fonts before drawing.
                function captureEngravingUrl() {
                  // Mode gate (defense-in-depth, mirrors renderEngravingText): reject loudly
                  // rather than upload a blank/leaked engraving. The only call site today is
                  // inside buildCartItems' Text branch, so this never fires in normal flow.
                  if (state.personalization !== 'Text' && state.personalization !== 'Combined') {
                    return Promise.reject(new Error('Engraving capture called outside Text mode'));
                  }
                  var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
                  return fontsReady.then(function () {
                    return new Promise(function (resolve, reject) {
                      var engravingCanvas = document.createElement('canvas');
                      engravingCanvas.width = 2000;
                      engravingCanvas.height = 800;
                      var ectx = engravingCanvas.getContext('2d');
                      renderEngravingText(ectx, engravingCanvas);
                      engravingCanvas.toBlob(function (blob) {
                        if (!blob) { return reject(new Error('Failed to create engraving blob')); }
                        var formData = new FormData();
                        formData.append('file', blob, 'engraving.png');
                        formData.append('upload_preset', uploadPreset);
                        fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', { method: 'POST', body: formData })
                          .then(function (res) { return res.json(); })
                          .then(function (data2) {
                            if (!data2 || !data2.secure_url) { return reject(new Error('Engraving upload returned no URL')); }
                            cfgLog('[configurator] engraving image uploaded:', data2.secure_url);
                            resolve(data2.secure_url);
                          })
                          .catch(reject);
                      }, 'image/png');
                    });
                  });
                }

                // Returns the index of the first Text-mode case that has text but no font chosen,
                // or -1. Used to block add-to-cart and tell the customer which case.
                function firstCaseMissingFont() {
                  saveActiveDesign();
                  for (var i = 0; i < designs.length; i++) {
                    var d = designs[i];
                    if (d.personalization === 'Text') {
                      var hasText = !!(d.textContent && d.textContent.trim());
                      if (hasText && !d.fontName) return i;
                    }
                  }
                  return -1;
                }

                // Returns the index of the first Image-mode case with no processed upload, or -1.
                // Used to hard-block add-to-cart and tell the customer which case.
                function firstCaseIncompleteImage() {
                  saveActiveDesign();
                  for (var i = 0; i < designs.length; i++) {
                    var d = designs[i];
                    if (d.personalization === 'Image') {
                      if (!(d.customImageReady && d.customImageUrl)) return i;
                    }
                  }
                  return -1;
                }

                // Returns the index of the first Text-mode case with no text entered, or -1.
                // Used to hard-block add-to-cart and tell the customer which case. Strict
                // 'Text' equality: a null (deselected) mode never matches, so plain adds
                // stay frictionless.
                function firstCaseEmptyText() {
                  saveActiveDesign();
                  for (var i = 0; i < designs.length; i++) {
                    var d = designs[i];
                    if (d.personalization === 'Text') {
                      if (!(d.textContent ?? '').trim()) return i;
                    }
                  }
                  return -1;
                }

                // Returns {index, mode} for the first case whose wallet is enabled with a
                // personalization mode selected but no content (Text with empty text, or
                // Image with no upload), or null. Wallet mode null (plain wallet) never
                // matches. Cases whose color has no matching available wallet variant are
                // SKIPPED — buildCartItems skips their wallet line anyway, so nothing
                // incomplete would ever reach the cart from them.
                function firstWalletIncomplete() {
                  saveActiveDesign();
                  for (var i = 0; i < designs.length; i++) {
                    var d = designs[i];
                    if (!d.walletEnabled) continue;
                    var cName = (d.colorEntry && d.colorEntry.colorName != null) ? d.colorEntry.colorName : null;
                    var wEntry = (cName && data.walletMap) ? data.walletMap[cName] : null;
                    if (!(wEntry && wEntry.variantId && wEntry.available)) continue;
                    if (d.walletPersonalization === 'Text') {
                      if (!(d.walletTextContent ?? '').trim()) return { index: i, mode: 'Text' };
                    } else if (d.walletPersonalization === 'Image') {
                      if (!d.walletCustomImageUrl) return { index: i, mode: 'Image' };
                    }
                  }
                  return null;
                }

                // Build the full items[] array: one case line (+ upgrade) and, if enabled, one
                // wallet line (+ upgrade) for EVERY design. Each case is loaded live so its own
                // engraving/mockup/wallet capture uses that case's state + images.
                async function buildCartItems() {
                  saveActiveDesign();
                  var items = [];
                  var ts = Date.now();
                  for (var i = 0; i < designs.length; i++) {
                    loadDesign(i);                          // swap state + images to case i (behind overlay)
                    await awaitDesignAssetsReady(designs[i]); // genuine readiness before capture
                    var lg = 'linked-' + ts + '-c' + i;
                    // Fee only when this case carries real content (matches the props gates
                    // below). Evaluated once; drives BOTH the _Linked Group attachment and
                    // the fee line so a fee-less case never forms a linked group.
                    var caseFeeOn = caseFeeAppliesTo(state.personalization, state.textContent, state.customImageUrl, state.customImageReady);
                    // No mode selected (null) → plain case line: omit Personalization Type
                    // entirely (never emit null as a property value), no fee, no _Linked Group.
                    var caseProps = {};
                    if (state.personalization) caseProps['Personalization Type'] = state.personalization;
                    if (caseFeeOn) caseProps['_Linked Group'] = lg;
                    if (state.personalization === 'Text') {
                      if (state.textContent && state.textContent.trim()) {
                        caseProps['Custom Text'] = state.textContent.trim();
                        if (state.fontName) caseProps['Font'] = state.fontName;
                        caseProps['_Engraving Image'] = await captureEngravingUrl();   // throws → aborts (never blank)
                      }
                    } else if (state.personalization === 'Image') {
                      if (state.customImageReady) {
                        if (state.customImageUrl) caseProps['_Custom Image URL'] = state.customImageUrl;
                        // Visible property (no underscore) — names the chosen preset design.
                        // state is per-case here: loadDesign(i) above restored designs[i].
                        if (state.presetDesignName) caseProps['Design'] = state.presetDesignName;
                        caseProps['_Order Preview'] = await captureCaseMockup(2);      // self-guards on unloaded image
                      }
                    }
                    var noteTrim = (state.customerNote ?? '').trim();
                    if (noteTrim) caseProps['Note'] = noteTrim;
                    var caseVid = (state.colorEntry && state.colorEntry.variantId != null) ? Number(state.colorEntry.variantId) : null;
                    if (caseVid) items.push({ id: caseVid, quantity: 1, properties: caseProps });
                    var up = caseFeeOn ? getCurrentUpgrade() : null;
                    if (up && up.id) items.push({ id: up.id, quantity: 1, properties: { '_Linked Group': lg } });
                    // This case's wallet (its own color-match + personalization), if enabled.
                    if (state.walletEnabled) {
                      var cName = (state.colorEntry && state.colorEntry.colorName != null) ? state.colorEntry.colorName : null;
                      var wEntry = (cName && data.walletMap) ? data.walletMap[cName] : null;
                      if (wEntry && wEntry.variantId && wEntry.available) {
                        var lgw = 'linked-w-' + ts + '-c' + i;
                        // Hoisted fee decision (content-gated inside getCurrentWalletUpgrade):
                        // the wallet only forms a linked group when a fee line will follow it.
                        var wUp = getCurrentWalletUpgrade();
                        var wProps = {};
                        if (wUp && wUp.id) wProps['_Linked Group'] = lgw;
                        var wHasContent = false;
                        if (state.walletPersonalization === 'Text') {
                          var wt = (state.walletTextContent ?? '').trim();
                          if (wt) { wProps['Personalization Type'] = 'Text'; wProps['Custom Text'] = wt; wProps['Font'] = state.walletFontName; wHasContent = true; }
                        } else if (state.walletPersonalization === 'Image') {
                          if (state.walletCustomImageUrl) { wProps['Personalization Type'] = 'Image'; wProps['_Custom Image URL'] = state.walletCustomImageUrl; wHasContent = true; }
                        }
                        if (wHasContent) {
                          try { var wm = await captureWalletMockup(); if (wm) wProps['_Order Preview'] = wm; }
                          catch (e) { cfgWarn('[velvetshieldz] wallet mockup capture failed for Case ' + (i + 1) + ' (line still added):', e); }
                        }
                        items.push({ id: Number(wEntry.variantId), quantity: 1, properties: wProps });
                        if (wUp && wUp.id) items.push({ id: wUp.id, quantity: 1, properties: { '_Linked Group': lgw } });
                      } else {
                        cfgWarn('[velvetshieldz] Case ' + (i + 1) + ' wallet enabled but no matching variant — skipping its wallet line');
                      }
                    }
                  }
                  return items;
                }

                // POST a pre-built items[] in one /cart/add.js request. Resolves→redirect on success;
                // throws on failure (the submit handler restores the active case + shows the error).
                function postCartItems(items) {
                  var bodyStr = JSON.stringify({ items: items });
                  cfgLog('[velvetshieldz] POSTing /cart/add.js —', items.length, 'line items, body length:', bodyStr.length);
                  return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: bodyStr
                  })
                    .then(function (res) {
                      cfgLog('[velvetshieldz] /cart/add.js status:', res.status);
                      if (!res.ok) {
                        return res.json().then(function (j) {
                          throw new Error((j && (j.description ?? j.message)) ?? ('Cart add failed: HTTP ' + res.status));
                        }, function () {
                          throw new Error('Cart add failed: HTTP ' + res.status);
                        });
                      }
                      return res.json();
                    })
                    .then(function () {
                      cfgLog('[velvetshieldz] multi-case cart add succeeded —', items.length, 'lines');
                      window.location.href = '/cart';
                    });
                }

                // Returns a promise that resolves once the engraving PNG has been uploaded to
                // Cloudinary and the hidden _Engraving Image input has been set. Does NOT submit
                // the cart — that's the submit handler's responsibility AFTER all needed
                // decorators have resolved.
                // Document-level event delegation in CAPTURE phase. The cart form is rendered
                // by buy-buttons.liquid LATER in the parse tree (main-product.liquid renders
                // product-info BEFORE buy-buttons), so the form doesn't exist in the DOM yet
                // when this IIFE runs. Form-level addEventListener at init time fails. document
                // always exists. Capture-phase at document fires DURING phase 1 of event
                // dispatch — strictly before any target-phase or bubble-phase listener on the
                // form, regardless of when those listeners attached. e.stopImmediatePropagation()
                // halts further dispatch including all target listeners (theme's _onSubmit and
                // any others), so the theme's competing FormData→/cart/add.js fetch never fires.
                document.addEventListener('submit', async function (e) {
                  var form = e.target;
                  if (!form || form.tagName !== 'FORM') return;
                  // Diagnostic: log every form submit reaching document — confirms the listener
                  // is wired correctly and shows which form is submitting. Temporary; remove
                  // after the dual-cart flow is verified working end-to-end.
                  cfgLog('[velvetshieldz] Submit event seen at document, form.is=',
                    form.getAttribute ? form.getAttribute('is') : null,
                    'form.action=', form.getAttribute ? form.getAttribute('action') : null);
                  // Filter: only intercept the cart form. Two matching strategies cover both
                  // Vitals' autonomous-customized form and the standard Shopify cart-add action.
                  var isCartForm = form.matches && (
                    form.matches('form[is="product-form"]') ||
                    form.matches('form[action*="/cart/add"]')
                  );
                  if (!isCartForm) return;

                  cfgLog('[velvetshieldz] Submit intercepted (capture phase at document)');
                  e.preventDefault();
                  e.stopImmediatePropagation();

                  // Empty-text gate across ALL cases — a Text-mode case with nothing typed
                  // can't be purchased (block + name the case). Runs BEFORE the font gate:
                  // ask for the text before asking for its font.
                  var emptyTextIdx = firstCaseEmptyText();
                  if (emptyTextIdx >= 0) {
                    if (emptyTextIdx !== activeIndex) switchToCase(emptyTextIdx);
                    showTextError();
                    showVisibleError('Case ' + (emptyTextIdx + 1) + ': Text selected but no text entered.');
                    return;
                  }

                  // Font gate across ALL cases (not just the active one) — block + name the case.
                  var missingFontIdx = firstCaseMissingFont();
                  if (missingFontIdx >= 0) {
                    if (missingFontIdx !== activeIndex) switchToCase(missingFontIdx);
                    showFontError();
                    showVisibleError('Please choose a font for Case ' + (missingFontIdx + 1) + ' before adding to cart.');
                    return;
                  }

                  // Image-completeness gate across ALL cases — an Image-mode case with no
                  // uploaded image can't be purchased (block + name the case).
                  var incompleteImageIdx = firstCaseIncompleteImage();
                  if (incompleteImageIdx >= 0) {
                    if (incompleteImageIdx !== activeIndex) switchToCase(incompleteImageIdx);
                    showVisibleError('Case ' + (incompleteImageIdx + 1) + ': Upload Image selected but no image added.');
                    var uploadBtn = root.querySelector('.cfg-upload__btn');
                    if (uploadBtn) {
                      uploadBtn.classList.add('cfg-input--error');
                      try {
                        uploadBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      } catch (err) {
                        uploadBtn.scrollIntoView();
                      }
                    }
                    return;
                  }

                  // Wallet content gate across ALL cases — an enabled wallet with a mode
                  // selected but no content can't be purchased (block + name the case).
                  // switchToCase → restoreWalletUI makes the offending wallet UI visible
                  // BEFORE the error is shown. Wallet mode null (plain wallet) passes.
                  var walletIncomplete = firstWalletIncomplete();
                  if (walletIncomplete) {
                    if (walletIncomplete.index !== activeIndex) switchToCase(walletIncomplete.index);
                    if (walletIncomplete.mode === 'Text') {
                      showWalletTextError();
                    } else {
                      showWalletUploadError('Case ' + (walletIncomplete.index + 1) + ' wallet: Upload Image selected but no image added.');
                      if (wUploadBtn) wUploadBtn.classList.add('cfg-input--error');
                      var wScrollTarget = wUploadBtn ?? wUploadError;
                      if (wScrollTarget) {
                        try {
                          wScrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        } catch (err) {
                          wScrollTarget.scrollIntoView();
                        }
                      }
                    }
                    return;
                  }

                  // Guard against an in-flight image upload on the active case (its processed image
                  // may not be captured yet). Other cases finished uploading before being switched away.
                  if (state.imageProcessing || state.walletImageProcessing) {
                    showVisibleError('An image is still processing — please wait a moment and tap Add to Cart again.');
                    return;
                  }

                  // ATC button → preparing state. Multiple fallback selectors cover varied
                  // theme button conventions; null-safe if none match.
                  var atcBtn = form.querySelector('button[type="submit"]')
                    || form.querySelector('button[name="add"]')
                    || form.querySelector('[data-add-to-cart-button]');
                  var originalText = atcBtn ? atcBtn.textContent : '';
                  if (atcBtn) {
                    atcBtn.disabled = true;
                    atcBtn.textContent = 'Preparing your order...';
                  }

                  // Capture EVERY case behind a freeze overlay (no visible cycling), then POST all
                  // line items in one request. On ANY failure (capture or POST), restore the
                  // customer to the case they started on and surface the error — never stranded.
                  var savedActiveIndex = activeIndex;
                  showCaptureOverlay();
                  try {
                    var items = await buildCartItems();
                    cfgLog('[velvetshieldz] built ' + items.length + ' cart line items:', JSON.parse(JSON.stringify(items)));
                    if (!items.length) { throw new Error('No line items were built'); }
                    await postCartItems(items);   // success → redirect to /cart (overlay stays until nav)
                  } catch (err) {
                    console.error('[velvetshieldz] multi-case add-to-cart failed:', err);
                    try { loadDesign(savedActiveIndex); } catch (e2) { cfgWarn('[velvetshieldz] active-case restore failed:', e2); }
                    hideCaptureOverlay();
                    restoreSubmitButton(atcBtn, originalText);
                    showVisibleError('Could not add to cart: ' + (err.message || 'Unknown error') + ' — please tap Add to Cart again to retry.');
                  }
                }, true);
                cfgLog('[velvetshieldz] Configurator submit listener attached at document (capture phase)');

                // Bug 2 fix: defensive ATC button reset. Real-mobile testing showed the
                // button can stay stuck on 'Preparing your order...' even after a full
                // page reload (bfcache is disqualified by Cache-Control: no-store on the
                // main resource, so event.persisted never becomes true — but stale form
                // state on mobile Safari / third-party app restoration still leaks the
                // loading label through). Detect the stuck label by prefix-match across
                // EN + SQ translations, reset to the saved originalText. Idempotent.
                function getATCButton() {
                  var form = resolveCartForm();
                  return form ? (form.querySelector('button[type="submit"]') || form.querySelector('button[name="add"]')) : null;
                }
                var STUCK_SIGNALS = ['Preparing', 'Processing', 'Po e përgatisim', 'Duke përgatitur'];
                function isStuckText(s) {
                  return STUCK_SIGNALS.some(function (sig) { return s.indexOf(sig) === 0; });
                }
                function captureInitialATCText() {
                  var btn = getATCButton();
                  if (!btn) return;
                  var txt = (btn.textContent || '').trim();
                  // Guard: never capture a stuck-state label as originalText, otherwise
                  // every future "reset" restores back to "Preparing…" — defeats the fix.
                  if (isStuckText(txt)) return;
                  if (!btn.dataset.originalText) {
                    btn.dataset.originalText = txt;
                  }
                }
                function checkAndResetATC() {
                  var btn = getATCButton();
                  if (!btn) return;
                  var current = (btn.textContent || '').trim();
                  if (!isStuckText(current)) return;
                  var restored = null;
                  if (btn.dataset.originalText && !isStuckText(btn.dataset.originalText)) {
                    restored = btn.dataset.originalText;
                  }
                  if (restored) {
                    cfgLog('[velvetshieldz] ATC button stuck ("' + current + '") — resetting to "' + restored + '"');
                    btn.textContent = restored;
                  } else {
                    cfgLog('[velvetshieldz] ATC button stuck ("' + current + '") but no safe originalText to restore — clearing busy state only');
                  }
                  btn.disabled = false;
                  btn.removeAttribute('aria-busy');
                }
                // DOMContentLoaded fires after the form is parsed. Run capture first (so a
                // legitimate label is saved BEFORE any stuck-state detection logic runs),
                // then immediately check for stuck state in case the page rehydrated with
                // a loading label already showing.
                document.addEventListener('DOMContentLoaded', function () {
                  captureInitialATCText();
                  checkAndResetATC();
                });
                window.addEventListener('load', checkAndResetATC);
                window.addEventListener('pageshow', function (e) {
                  if (e.persisted) {
                    cfgLog('[velvetshieldz] Page restored from bfcache — resetting ATC button state');
                  }
                  checkAndResetATC();
                });

                /* ===== WALLET ADD-ON (Step 2 — matched-wallet card) ===== */
                var walletAddOn = false;
                var wMap    = (data && data.walletMap) ? data.walletMap : {};
                var wCard   = document.getElementById('cfg-wallet-section-' + BLOCK_ID);
                var wToggle = document.getElementById('cfg-wallet-toggle-' + BLOCK_ID);
                var wImg    = document.getElementById('cfg-wallet-img-' + BLOCK_ID);
                var wName   = document.getElementById('cfg-wallet-name-' + BLOCK_ID);
                var wPrice  = document.getElementById('cfg-wallet-price-' + BLOCK_ID);
                var wCompare  = document.getElementById('cfg-wallet-compare-' + BLOCK_ID);
                var wDiscount = document.getElementById('cfg-wallet-discount-' + BLOCK_ID);
                var wUpgradeAdd = document.getElementById('cfg-wallet-upgrade-add-' + BLOCK_ID);
                var wPersonalize = document.getElementById('cfg-wallet-personalize-' + BLOCK_ID);
                var wTextPanel   = document.getElementById('cfg-wallet-text-panel-' + BLOCK_ID);
                var wImagePanel  = document.getElementById('cfg-wallet-image-panel-' + BLOCK_ID);
                var wTextInput   = document.getElementById('cfg-wallet-textinput-' + BLOCK_ID);
                var wTextError   = document.getElementById('cfg-wallet-text-error-' + BLOCK_ID);
                var wFontSelect  = document.getElementById('cfg-wallet-font-' + BLOCK_ID);
                var wPills = wPersonalize ? wPersonalize.querySelectorAll('.cfg-wallet-pill') : [];
                var walletHasMatch = false;
                var wFileInput   = document.getElementById('cfg-wallet-file-' + BLOCK_ID);
                var wUploadBtn   = wImagePanel ? wImagePanel.querySelector('.cfg-wallet-upload-btn') : null;
                var wUploadLabel = document.querySelector('#cfg-wallet-image-panel-' + BLOCK_ID + ' [data-cfg-wallet-upload-label]');
                var wUploadThumb = document.getElementById('cfg-wallet-upload-thumb-' + BLOCK_ID);
                var wUploadRemove= document.getElementById('cfg-wallet-upload-remove-' + BLOCK_ID);
                var wUploadError = document.getElementById('cfg-wallet-upload-error-' + BLOCK_ID);

                function applyWalletForColor(entry) {
                  if (!wCard) return;
                  var name = (entry != null) ? entry.colorName : null;
                  var w = (name != null) ? wMap[name] : null;
                  var hasWallet = (w != null) && (w.available === true);
                  if (hasWallet) {
                    if (wImg)   { wImg.src = (w.image != null ? w.image : ''); wImg.alt = (w.title != null ? w.title : ''); }
                    if (wName)  { wName.textContent  = (w.title != null ? w.title : ''); }
                    if (wPrice) { wPrice.innerHTML = (w.priceFormatted != null ? w.priceFormatted : ''); }
                    if (wCompare)  { wCompare.innerHTML  = (w.compareAtFormatted != null ? w.compareAtFormatted : ''); }
                    if (wDiscount) { wDiscount.textContent = (w.discountPct != null && w.discountPct > 0 ? 'Save ' + w.discountPct + '%' : ''); }
                    // Warm the HTTP cache for this color's preview base image so the first
                    // pill click draws near-instantly. Fire-and-forget — no handlers, no
                    // state; renderWalletPreview's load branch does the real (CORS) load.
                    if (w.previewImage) { (new Image()).src = w.previewImage; }
                  }
                  // Stage A: every case has its own wallet, so the block shows whenever a matching
                  // wallet variant exists for THIS case's color (no more 1-case gate). walletHasMatch
                  // drives the active case's tray/preview/cart-eligibility.
                  wCard.hidden = !hasWallet;
                  walletHasMatch = hasWallet;
                  updateWalletTrayVisibility();
                  updateWalletUpgradeAdd();
                  scheduleWalletRender();
                }

                function updateWalletTrayVisibility() {
                  if (!wPersonalize) return;
                  wPersonalize.hidden = !(walletHasMatch && wToggle && wToggle.checked);
                }
                function updateWalletUpgradeAdd() {
                  if (!wUpgradeAdd) return;
                  // Mode-gated: chip appears the moment a wallet mode is selected (committed price).
                  wUpgradeAdd.hidden = !(walletHasMatch && wToggle && wToggle.checked && walletModeSelected());
                  // Per-mode price spans are Liquid-prerendered (raw-EUR .money inside, so the
                  // Vitals converter keeps working) — JS only toggles visibility, never text.
                  var feeSpans = wUpgradeAdd.querySelectorAll('[data-wallet-fee-mode]');
                  for (var fi = 0; fi < feeSpans.length; fi++) {
                    feeSpans[fi].hidden = feeSpans[fi].getAttribute('data-wallet-fee-mode') !== state.walletPersonalization;
                  }
                }
                function selectWalletPersonalization(type) {
                  state.walletPersonalization = type;
                  for (var i = 0; i < wPills.length; i++) {
                    var p = wPills[i];
                    var active = p.getAttribute('data-wallet-personalization') === type;
                    p.classList.toggle('is-active', active);
                    p.setAttribute('aria-pressed', active ? 'true' : 'false');
                    // Red "remove" X badge on the selected wallet pill — mirrors the case
                    // pills (selectPersonalization). Purely visual (pointer-events: none in
                    // CSS; no handler of its own, clicks fall through to the pill's existing
                    // toggle-off). Synced here so it tracks the ACTIVE case's wallet mode:
                    // case switches re-enter via restoreWalletUI → selectWalletPersonalization.
                    var xBadge = p.querySelector('.cfg-wallet-pill__x');
                    if (active) {
                      if (!xBadge) {
                        xBadge = document.createElement('span');
                        xBadge.className = 'cfg-wallet-pill__x';
                        xBadge.setAttribute('aria-hidden', 'true');
                        xBadge.textContent = '×';
                        p.appendChild(xBadge);
                      }
                      var wLabelText = p.getAttribute('data-wallet-personalization');
                      p.setAttribute('aria-label', wLabelText + ' personalization selected — click to remove');
                    } else {
                      if (xBadge) xBadge.remove();
                      // Drop the override so the pill's accessible name falls back to its
                      // visible label + price spans.
                      p.removeAttribute('aria-label');
                    }
                  }
                  if (wTextPanel)  wTextPanel.hidden  = (type !== 'Text');
                  if (wImagePanel) wImagePanel.hidden = (type !== 'Image');
                  // Deselect (null): drop any stale red border / error message. Error UI only —
                  // content (text / image / font / size) is deliberately retained, matching the
                  // case X. Does NOT call removeWalletImage.
                  if (type == null) {
                    clearWalletTextError();
                    hideWalletUploadError();
                  }
                  scheduleWalletRender();
                  refreshRunningTotal();
                  refreshCasesTotal();
                  updateWalletUpgradeAdd();
                }

                if (wToggle) {
                  wToggle.addEventListener('change', function () {
                    walletAddOn = wToggle.checked;
                    state.walletEnabled = wToggle.checked;   // per-case toggle (Stage A) — persists on switch
                    updateWalletTrayVisibility();
                    refreshRunningTotal();
                    refreshCasesTotal();
                    updateWalletUpgradeAdd();
                    scheduleWalletRender();
                  });
                }
                for (var i = 0; i < wPills.length; i++) {
                  (function (p) { p.addEventListener('click', function () {
                    var wMode = p.getAttribute('data-wallet-personalization');
                    // Toggle-off (mirrors the case pills): clicking the active pill
                    // deselects. Wallet content (text / uploaded image / font) is retained
                    // — selectWalletPersonalization clears nothing — so re-selecting
                    // restores the panel intact.
                    selectWalletPersonalization(wMode === state.walletPersonalization ? null : wMode);
                  }); })(wPills[i]);
                }
                if (wTextInput) { wTextInput.addEventListener('input', function () { state.walletTextContent = wTextInput.value; clearWalletTextError(); scheduleWalletRender(); refreshRunningTotal(); refreshCasesTotal(); updateWalletUpgradeAdd(); }); }
                if (wFontSelect) { wFontSelect.addEventListener('change', function () {
                  state.walletFontFamily = wFontSelect.value;
                  state.walletFontName = wFontSelect.options[wFontSelect.selectedIndex] ? wFontSelect.options[wFontSelect.selectedIndex].text : '';
                  // Load the chosen face before drawing so a not-yet-loaded font (e.g. self-hosted
                  // Velvet Bold / Aerosoldier) doesn't draw as a silent fallback. Quote multi-word names.
                  try {
                    if (document.fonts && document.fonts.load && state.walletFontFamily) {
                      document.fonts.load('1em "' + state.walletFontFamily + '"').then(scheduleWalletRender, scheduleWalletRender);
                    }
                  } catch (e) { /* ignore parse issues; render below still runs */ }
                  scheduleWalletRender();
                }); }
                selectWalletPersonalization(state.walletPersonalization);

                function showWalletUploadError(msg) { if (wUploadError) { wUploadError.textContent = msg; wUploadError.hidden = false; } }
                function hideWalletUploadError() {
                  if (wUploadError) { wUploadError.hidden = true; wUploadError.textContent = ''; }
                  if (wUploadBtn) wUploadBtn.classList.remove('cfg-input--error');
                }
                // Wallet empty-text cart-gate UI. Mirrors the case-side showTextError/
                // clearTextError pair: red border on the wallet text input + the inline
                // .cfg-wallet-text-error message + scroll-to.
                function showWalletTextError() {
                  if (wTextInput) wTextInput.classList.add('cfg-input--error');
                  if (wTextError) wTextError.hidden = false;
                  var target = wTextInput ?? wTextError;
                  if (target) {
                    try {
                      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    } catch (err) {
                      target.scrollIntoView();
                    }
                  }
                  cfgLog('[configurator] wallet text empty - blocked submit');
                }
                function clearWalletTextError() {
                  if (wTextInput) wTextInput.classList.remove('cfg-input--error');
                  if (wTextError) wTextError.hidden = true;
                }
                function showWalletUploadPreview(url) {
                  state.walletCustomImageUrl = url;
                  if (wUploadThumb) { wUploadThumb.src = url; wUploadThumb.hidden = false; }
                  if (wUploadRemove) wUploadRemove.hidden = false;
                  if (wUploadLabel) wUploadLabel.textContent = (data.replaceLabel ?? 'Replace image');
                  processWalletImageForPreview(url);
                  refreshRunningTotal(); refreshCasesTotal(); updateWalletUpgradeAdd();
                }
                function removeWalletImage() {
                  state.walletCustomImageUrl = null;
                  state.walletCustomImageReady = false;
                  if (wUploadThumb) { wUploadThumb.hidden = true; wUploadThumb.src = ''; }
                  if (wUploadRemove) wUploadRemove.hidden = true;
                  if (wFileInput) wFileInput.value = '';
                  if (wUploadLabel) wUploadLabel.textContent = (data.uploadLabel ?? 'Upload image');
                  state.walletProcessedDataUrl = null;
                  state.walletImageProcessing = false;
                  state.walletImageProcessError = null;
                  if (wWrap) wWrap.classList.remove('is-processing');
                  hideWalletUploadError();
                  scheduleWalletRender();
                  refreshRunningTotal(); refreshCasesTotal(); updateWalletUpgradeAdd();
                }
                function uploadWalletImage(file) {
                  var mimeOk = UPLOAD_ALLOWED_MIME.test(file.type);
                  var extOk  = UPLOAD_ALLOWED_EXT.test(file.name);
                  if (!(mimeOk || extOk)) { showWalletUploadError('Please upload a PNG, JPG, WEBP, or HEIC image.'); return; }
                  if (file.size > UPLOAD_MAX_BYTES) { showWalletUploadError('Image must be under 10 MB.'); return; }
                  hideWalletUploadError();
                  if (wUploadBtn) wUploadBtn.classList.add('is-busy');
                  if (wUploadLabel) wUploadLabel.textContent = 'Uploading...';
                  var fd = new FormData();
                  fd.append('file', file);
                  fd.append('upload_preset', data.uploadPreset);
                  fetch('https://api.cloudinary.com/v1_1/' + data.cloudName + '/image/upload', { method: 'POST', body: fd })
                    .then(function (r) { return r.json(); })
                    .then(function (res) {
                      if (res && res.secure_url) { showWalletUploadPreview(res.secure_url); }
                      else { showWalletUploadError('Upload failed. Please try again.'); if (wUploadLabel) wUploadLabel.textContent = (data.uploadLabel ?? 'Upload image'); }
                    })
                    .catch(function () { showWalletUploadError('Upload failed. Please try again.'); if (wUploadLabel) wUploadLabel.textContent = (data.uploadLabel ?? 'Upload image'); })
                    .finally(function () { if (wUploadBtn) wUploadBtn.classList.remove('is-busy'); });
                }
                if (wFileInput) { wFileInput.addEventListener('change', function () {
                  if (wFileInput.files && wFileInput.files[0]) uploadWalletImage(wFileInput.files[0]);
                }); }
                if (wUploadRemove) { wUploadRemove.addEventListener('click', removeWalletImage); }

                var wPreview    = document.getElementById('cfg-wallet-preview-' + BLOCK_ID);
                var wPreviewCtx = wPreview ? wPreview.getContext('2d') : null;
                var wWrap       = document.getElementById('cfg-wallet-preview-wrap-' + BLOCK_ID);
                var wProcessedImageCache = null, wProcessedImageCacheUrl = null;
                var wSizeWrap   = document.getElementById('cfg-wallet-size-' + BLOCK_ID);
                var wSizeSlider = document.getElementById('cfg-wallet-size-slider-' + BLOCK_ID);
                var wSizeValue  = wSizeWrap ? wSizeWrap.querySelector('.cfg-wallet-size-value') : null;
                if (wSizeSlider) wSizeSlider.style.setProperty('--fill', (state.walletSizeScale ?? 50) + '%');
                var wBaseImg = null, wBaseUrl = null, wRafId = null;
                var WALLET_TEXT = { x: 0.24, y: 0.40, w: 0.52, h: 0.18 };
                var WALLET_IMG_MIN = 0.12, WALLET_IMG_MAX = 0.45;
                var WALLET_ENGRAVE = '#000000';
                function walletPreviewBaseUrl() {
                  var name = (state.colorEntry != null) ? state.colorEntry.colorName : null;
                  var w = (name != null) ? wMap[name] : null;
                  return (w && w.previewImage) ? w.previewImage : '';
                }
                // Mode-gated: a selected mode unhides the preview wrap on the very next
                // render (as a bordered skeleton box until the base image finishes loading —
                // see the load branch in renderWalletPreview). The content branches early-
                // return while text/image are still empty, so the blank state renders.
                function walletPreviewShouldShow() {
                  if (!(walletHasMatch && wToggle && wToggle.checked)) return false;
                  return walletModeSelected();
                }
                function scheduleWalletRender() {
                  if (wRafId) cancelAnimationFrame(wRafId);
                  wRafId = requestAnimationFrame(function () { renderWalletPreview(); wRafId = null; });
                }
                function processWalletImageForPreview(cloudinaryUrl) {
                  state.walletImageProcessing = true;
                  state.walletImageProcessError = null;
                  state.walletCustomImageReady = false;
                  state.walletProcessedDataUrl = null;
                  if (wWrap) wWrap.classList.add('is-processing');
                  scheduleWalletRender();
                  var bgUrl = buildBackgroundRemovalUrl(cloudinaryUrl);
                  return pollForBackgroundRemovedImage(bgUrl, 60, 1000)
                    .then(fetchImageAsDataUrl)
                    .then(processImageWithSmartThreshold)
                    .then(function (dataUrl) {
                      return new Promise(function (resolve) {
                        var img = new Image();
                        img.onload  = function () { var t = autoTrimAlpha(img, 10); resolve(t === img ? dataUrl : t.toDataURL('image/png')); };
                        img.onerror = function () { resolve(dataUrl); };
                        img.src = dataUrl;
                      });
                    })
                    .then(function (finalUrl) {
                      state.walletProcessedDataUrl = finalUrl;
                      state.walletImageProcessing = false;
                      state.walletCustomImageReady = true;
                      if (wWrap) wWrap.classList.remove('is-processing');
                      scheduleWalletRender();
                    })
                    .catch(function (err) {
                      state.walletImageProcessing = false;
                      state.walletCustomImageReady = false;
                      state.walletImageProcessError = (err && err.message) || 'Preview failed';
                      if (wWrap) wWrap.classList.remove('is-processing');
                      showWalletUploadError('Preview failed: ' + ((err && err.message) || 'try again'));
                      scheduleWalletRender();
                    });
                }
                function renderWalletPreview() {
                  if (!wPreview || !wPreviewCtx || !wWrap) return;
                  var show = walletPreviewShouldShow();
                  var baseUrl = show ? walletPreviewBaseUrl() : '';
                  if (!show || !baseUrl) { wWrap.hidden = true; if (wSizeWrap) wSizeWrap.hidden = true; return; }
                  // Unhide BEFORE the load branch: the bordered square is the skeleton while
                  // the base image loads, so mode selection shows the preview slot on this
                  // same render instead of waiting for the image's onload re-render.
                  wWrap.hidden = false;
                  if (wBaseUrl !== baseUrl) {
                    wBaseUrl = baseUrl;
                    // New base incoming (first load or color change): resetting the canvas
                    // size clears the old composite so the previous color's wallet can't
                    // flash while the new base loads. Slider stays content-gated + hidden.
                    wPreview.width = 600; wPreview.height = 600;
                    if (wSizeWrap) wSizeWrap.hidden = true;
                    wBaseImg = new Image(); wBaseImg.crossOrigin = 'anonymous';
                    wBaseImg.onload  = function () { renderWalletPreview(); };
                    // Failed load: reset wBaseUrl so the next render re-enters this load
                    // branch and retries, instead of dead-ending forever at the
                    // naturalWidth guard below.
                    wBaseImg.onerror = function () { wBaseUrl = null; wWrap.hidden = true; if (wSizeWrap) wSizeWrap.hidden = true; };
                    wBaseImg.src = baseUrl; return;
                  }
                  if (!wBaseImg || !wBaseImg.complete || !wBaseImg.naturalWidth) return;
                  wWrap.hidden = false;
                  // Size slider only once the mode's content exists (non-empty text / processed
                  // image) — the blank/plain preview renders without a functionless control.
                  if (wSizeWrap) {
                    var wSliderOn = (state.walletPersonalization === 'Text')
                      ? !!(state.walletTextContent ?? '').trim()
                      : !!state.walletProcessedDataUrl;
                    wSizeWrap.hidden = !wSliderOn;
                  }
                  wPreview.width = 600; wPreview.height = 600;
                  var ctx = wPreviewCtx; ctx.clearRect(0, 0, 600, 600);
                  var s = Math.min(600 / wBaseImg.naturalWidth, 600 / wBaseImg.naturalHeight);
                  var dW = wBaseImg.naturalWidth * s, dH = wBaseImg.naturalHeight * s;
                  ctx.drawImage(wBaseImg, (600 - dW) / 2, (600 - dH) / 2, dW, dH);
                  var dx = (600 - dW) / 2, dy = (600 - dH) / 2;
                  var scale = (state.walletSizeScale ?? 50) / 100;
                  if (state.walletPersonalization === 'Text') {
                    var txt = (state.walletTextContent || '').trim();
                    if (!txt) return;
                    var taX = dx + dW * WALLET_TEXT.x, taY = dy + dH * WALLET_TEXT.y;
                    var taW = dW * WALLET_TEXT.w,      taH = dH * WALLET_TEXT.h;
                    var fontSize = taH * (0.45 + scale * 0.55);
                    var fam = state.walletFontFamily || 'sans-serif';
                    ctx.font = fontSize + 'px ' + fam;
                    var m = ctx.measureText(txt);
                    var tw = (m.actualBoundingBoxLeft != null && m.actualBoundingBoxRight != null) ? (m.actualBoundingBoxLeft + m.actualBoundingBoxRight) : m.width;
                    if (tw > taW && tw > 0) { fontSize = fontSize * (taW / tw); ctx.font = fontSize + 'px ' + fam; }
                    ctx.fillStyle = WALLET_ENGRAVE; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
                    ctx.fillText(txt, taX + taW / 2, taY + taH / 2);
                  } else if (state.walletPersonalization === 'Image') {
                    if (!state.walletProcessedDataUrl) return;
                    if (wProcessedImageCacheUrl !== state.walletProcessedDataUrl) {
                      wProcessedImageCache = new Image();
                      wProcessedImageCacheUrl = state.walletProcessedDataUrl;
                      wProcessedImageCache.onload = function () { renderWalletPreview(); };
                      wProcessedImageCache.src = state.walletProcessedDataUrl;
                      return;
                    }
                    if (!wProcessedImageCache.complete || !wProcessedImageCache.naturalWidth) return;
                    var iw = wProcessedImageCache.naturalWidth, ih = wProcessedImageCache.naturalHeight;
                    var box = WALLET_IMG_MIN + scale * (WALLET_IMG_MAX - WALLET_IMG_MIN);
                    var fit = Math.min((dW * box) / iw, (dH * box) / ih);
                    var drawW = iw * fit, drawH = ih * fit;
                    var cx = dx + dW / 2, cy = dy + dH * 0.46;
                    ctx.drawImage(wProcessedImageCache, cx - drawW / 2, cy - drawH / 2, drawW, drawH);
                  }
                }
                function captureWalletMockup() {
                  return new Promise(function (resolve, reject) {
                    // Mode+content gate (defense-in-depth, mirrors captureEngravingUrl):
                    // walletFeeApplies() is true only for an ACTIVE Text/Image mode whose
                    // content exists, so a deselected wallet with retained content can
                    // never upload a mockup, regardless of call site. Sole caller today
                    // sits behind wHasContent in buildCartItems.
                    if (!walletFeeApplies()) { reject(new Error('Wallet mockup capture called without an active wallet mode + content')); return; }
                    if (!wPreview) { reject(new Error('No wallet preview canvas')); return; }
                    renderWalletPreview();   // ensure the current composite is drawn
                    wPreview.toBlob(function (blob) {
                      if (!blob) { reject(new Error('Failed to capture wallet mockup blob')); return; }
                      var formData = new FormData();
                      formData.append('file', blob, 'wallet-mockup.png');
                      formData.append('upload_preset', uploadPreset);
                      fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', { method: 'POST', body: formData })
                        .then(function (r) { if (!r.ok) throw new Error('Wallet mockup upload failed: HTTP ' + r.status); return r.json(); })
                        .then(function (result) { if (!result || !result.secure_url) throw new Error('Cloudinary returned no secure_url for wallet mockup'); resolve(result.secure_url); })
                        .catch(reject);
                    }, 'image/png');
                  });
                }
                if (wSizeSlider) { wSizeSlider.addEventListener('input', function () {
                  var v = parseInt(wSizeSlider.value, 10);
                  state.walletSizeScale = isNaN(v) ? 50 : v;
                  wSizeSlider.style.setProperty('--fill', state.walletSizeScale + '%');
                  if (wSizeValue) wSizeValue.textContent = state.walletSizeScale + '%';
                  scheduleWalletRender();
                }); }

                if (window.cfgDebug) {
                  try {
                    var wExpected = Object.keys(data.colorHexMap || {});
                    console.group('[wallet] handle resolution (' + Object.keys(wMap).length + '/' + wExpected.length + ' resolved)');
                    wExpected.forEach(function (nm) {
                      var r = wMap[nm];
                      cfgLog(nm, r ? ('RESOLVED -> ' + r.handle + ' | ' + r.priceFormatted + ' | avail=' + r.available + ' | img=' + (r.image ? 'yes' : 'no')) : 'MISSING');
                    });
                    console.groupEnd();
                  } catch (e) { cfgWarn('[wallet] debug echo failed', e); }
                }
                /* ===== END WALLET ADD-ON ===== */

                // ============================================================================
                // MULTI-CASE BUILDER (Stage 2) — state array + tab switching + add/remove.
                // `state` stays the ACTIVE design's live working object (+ globals: wallet*,
                // upgradePrices). `designs[]` snapshots each case's PER-CASE fields; activeIndex
                // is the case being edited. Cart wiring is Stage 5 (not built here).
                // ============================================================================
                var MAX_CASES = 5;
                var DESIGN_FIELDS = [
                  'model', 'colorEntry', 'personalization',
                  'fontFamily', 'fontName', 'textContent', 'customerNote',
                  'customImageUrl', 'imageProcessedDataUrl', 'customImageReady',
                  'imageProcessing', 'imageProcessError', 'presetDesignName',
                  'sizeScale', 'textPositionY', 'imageSize', 'imagePositionY', 'imageOpacity',
                  // Per-case wallet (Stage A). walletImageProcessing / walletImageProcessError are
                  // deliberately EXCLUDED — those transient flags are reset on load, never restored.
                  'walletEnabled', 'walletPersonalization', 'walletTextContent',
                  'walletFontName', 'walletFontFamily', 'walletCustomImageUrl',
                  'walletCustomImageReady', 'walletSizeScale', 'walletProcessedDataUrl', 'walletMockupUrl'
                ];
                var designs = [];
                var activeIndex = 0;
                var casesEl = root.querySelector('.cfg-cases');
                var removeModal = root.querySelector('[data-cfg-remove-modal]');
                var pendingRemoveIndex = null;
                var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

                function snapshotActiveDesign() {
                  var d = {};
                  for (var i = 0; i < DESIGN_FIELDS.length; i++) { d[DESIGN_FIELDS[i]] = state[DESIGN_FIELDS[i]]; }
                  return d;
                }
                function saveActiveDesign() {
                  if (!designs[activeIndex]) return;
                  // Keep state.textContent current with the textarea before snapshotting.
                  if (textarea && state.personalization === 'Text') state.textContent = textarea.value;
                  for (var i = 0; i < DESIGN_FIELDS.length; i++) { designs[activeIndex][DESIGN_FIELDS[i]] = state[DESIGN_FIELDS[i]]; }
                }
                function makeBlankDesign() {
                  return {
                    model: sortedModels[0], colorEntry: null, personalization: null,
                    fontFamily: '', fontName: '', textContent: '', customerNote: '',
                    customImageUrl: null, imageProcessedDataUrl: null, customImageReady: false,
                    imageProcessing: false, imageProcessError: null, presetDesignName: null,
                    sizeScale: sliderDefault, textPositionY: 50,
                    imageSize: 100, imagePositionY: 50, imageOpacity: 1,
                    walletEnabled: false, walletPersonalization: null,
                    walletTextContent: '', walletFontName: defaultFontName, walletFontFamily: defaultFontFamily,
                    walletCustomImageUrl: null, walletCustomImageReady: false,
                    walletSizeScale: 50, walletProcessedDataUrl: null, walletMockupUrl: null
                  };
                }
                // Reflect state.fontName/fontFamily into the font dropdown (decoy-aware).
                function applyFontToDropdown() {
                  if (!fontDropdown) return;
                  var lbl = fontDropdown.querySelector('.cfg-dropdown__label');
                  var items = fontDropdown.querySelectorAll('.cfg-dropdown__item');
                  if (state.fontName) {
                    if (lbl) { lbl.textContent = state.fontName; lbl.style.fontFamily = state.fontFamily; lbl.classList.remove('cfg-dropdown__label--placeholder'); }
                    items.forEach(function (it) { it.setAttribute('aria-selected', it.getAttribute('data-font-name') === state.fontName ? 'true' : 'false'); });
                  } else {
                    if (lbl) { lbl.textContent = 'Choose your font'; lbl.style.fontFamily = ''; lbl.classList.add('cfg-dropdown__label--placeholder'); }
                    items.forEach(function (it) { it.setAttribute('aria-selected', 'false'); });
                  }
                }
                // Reflect the active design's image state into the upload UI.
                function restoreImageUI() {
                  if (state.customImageReady && state.customImageUrl) {
                    if (uploadThumb) { uploadThumb.src = state.customImageUrl; uploadThumb.hidden = false; }
                    if (uploadLbl) uploadLbl.textContent = replaceLabel;
                    if (propImage) { propImage.value = state.customImageUrl; propImage.disabled = false; }
                  } else {
                    if (uploadThumb) { uploadThumb.removeAttribute('src'); uploadThumb.hidden = true; }
                    if (uploadLbl) uploadLbl.textContent = data.uploadLabel;
                    if (propImage) { propImage.value = ''; propImage.disabled = true; }
                  }
                  if (typeof syncImageActionsVisibility === 'function') syncImageActionsVisibility();
                }
                // Restore the active case's wallet UI from state (toggle, tray, mode, text/font,
                // image thumbnail, size). The wallet preview cache self-invalidates on
                // walletProcessedDataUrl change, like the main image.
                function restoreWalletUI() {
                  if (wToggle) wToggle.checked = !!state.walletEnabled;
                  walletAddOn = !!state.walletEnabled;
                  // null (deselected wallet mode) round-trips per case — no re-seed to Text.
                  selectWalletPersonalization(state.walletPersonalization);
                  if (wTextInput) wTextInput.value = state.walletTextContent ?? '';
                  if (wFontSelect && state.walletFontFamily) wFontSelect.value = state.walletFontFamily;
                  if (state.walletCustomImageReady && state.walletCustomImageUrl) {
                    if (wUploadThumb) { wUploadThumb.src = state.walletCustomImageUrl; wUploadThumb.hidden = false; }
                    if (wUploadRemove) wUploadRemove.hidden = false;
                    if (wUploadLabel) wUploadLabel.textContent = (data.replaceLabel ?? 'Replace image');
                  } else {
                    if (wUploadThumb) { wUploadThumb.hidden = true; wUploadThumb.src = ''; }
                    if (wUploadRemove) wUploadRemove.hidden = true;
                    if (wUploadLabel) wUploadLabel.textContent = (data.uploadLabel ?? 'Upload image');
                  }
                  if (wWrap) wWrap.classList.remove('is-processing');
                  if (typeof hideWalletUploadError === 'function') hideWalletUploadError();
                  if (typeof clearWalletTextError === 'function') clearWalletTextError();
                  if (wSizeSlider) { wSizeSlider.value = (state.walletSizeScale ?? 50); wSizeSlider.style.setProperty('--fill', (state.walletSizeScale ?? 50) + '%'); }
                  if (wSizeValue) wSizeValue.textContent = (state.walletSizeScale ?? 50) + '%';
                  updateWalletTrayVisibility();
                  updateWalletUpgradeAdd();
                  scheduleWalletRender();
                }
                // Load designs[i] into the live state + drive EVERY control (right column +
                // left-column sliders) + re-render. Round-trips every per-case field.
                function loadDesign(i) {
                  if (i < 0 || i >= designs.length) return;
                  activeIndex = i;
                  var d = designs[i];
                  for (var k = 0; k < DESIGN_FIELDS.length; k++) { state[DESIGN_FIELDS[k]] = d[DESIGN_FIELDS[k]]; }
                  // Model + color: selectModel auto-picks first-available color, so restore the
                  // saved color afterwards (its entry object stays valid — modelMap is stable).
                  selectModel(state.model ?? sortedModels[0]);
                  if (d.colorEntry) selectColor(d.colorEntry);
                  // Font dropdown (decoy-aware) + clear any stale font/empty-text gate errors.
                  applyFontToDropdown();
                  if (typeof clearFontError === 'function') clearFontError();
                  if (typeof clearTextError === 'function') clearTextError();
                  // Text content + counter (set BEFORE selectPersonalization so Text mode reads it).
                  if (textarea) { textarea.value = state.textContent ?? ''; updateCharCounter(textarea, textCounter); if (typeof autoResizeTextarea === 'function') autoResizeTextarea(textarea); }
                  // Image UI.
                  restoreImageUI();
                  // Wallet: reset transient flags (never restore an in-flight upload / stale error),
                  // then restore this case's full wallet UI from state.
                  state.walletImageProcessing = false;
                  state.walletImageProcessError = null;
                  restoreWalletUI();
                  // Personalization mode → panels, propType/propText/propImage/propFont, slider
                  // visibility. null (deselected) round-trips as-is — no silent revert to Text.
                  selectPersonalization(state.personalization);
                  // Sliders → both mobile (product-info) and desktop (media.liquid) instances.
                  syncSlidersVisibility();
                  syncSlidersValues();
                  scheduleRender();
                }

                var casesTotalEl = root.querySelector('[data-cfg-cases-total]');
                var savePillTemplate = data.savePillTemplate ?? '-{percent}%';

                // ----- Live combined price (DISPLAY ONLY — does not affect the cart POST) -----
                // Per case: base = data.variants[].price, compare-at = data.variants[].compare_at_price
                // (both integer cents), plus that case's tier upgrade added to BOTH current and compare.
                // Summed exactly in cents, formatted once. 1 case → the normal single-variant price
                // path owns the prominent line; >1 case → the combined totals below replace it.
                function variantFieldCents(variantId, field) {
                  var vs = data.variants ?? [];
                  for (var i = 0; i < vs.length; i++) {
                    if (Number(vs[i].id) === Number(variantId)) return Number(vs[i][field]) || 0;
                  }
                  return 0;
                }
                function variantPriceCents(variantId) { return variantFieldCents(variantId, 'price'); }
                function variantCompareCents(variantId) { return variantFieldCents(variantId, 'compare_at_price'); }
                // Approach (a): the store is EUR-only and a client-side converter (Pop Convert) rewrites
                // .money element text to the customer's currency. So we sum raw EUR cents and emit the
                // total as a <span class="money"> EUR string; the converter does the rest, exactly like
                // single-case prices and the Made-to-Match carriers. No JS currency conversion.
                function formatMoneyCents(cents) {
                  var fmt = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat)
                            || (window.Shopify && Shopify.money_format)
                            || '€{{amount}}';
                  function fmtNumber(num, precision, thousands, decimal) {
                    var fixed = (num / 100).toFixed(precision);
                    var parts = fixed.split('.');
                    var intPart = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + (thousands ?? ','));
                    var decPart = (parts.length > 1) ? (decimal ?? '.') + parts[1] : '';
                    return intPart + decPart;
                  }
                  var amount = fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
                    switch (token) {
                      case 'amount': return fmtNumber(cents, 2, ',', '.');
                      case 'amount_no_decimals': return fmtNumber(cents, 0, ',', '.');
                      case 'amount_with_comma_separator': return fmtNumber(cents, 2, '.', ',');
                      case 'amount_no_decimals_with_comma_separator': return fmtNumber(cents, 0, '.', ',');
                      case 'amount_with_apostrophe_separator': return fmtNumber(cents, 2, '’', '.');
                      default: return fmtNumber(cents, 2, ',', '.');
                    }
                  });
                  // Ensure exactly one .money wrapper (match single-case / Made-to-Match) so Pop Convert
                  // processes it; if money_format already includes class="money", keep the string as-is.
                  return /class\s*=\s*["']?[^"'>]*\bmoney\b/.test(amount) ? amount : '<span class="money">' + amount + '</span>';
                }
                // Sum current + compare-at across all cases (active uses live state; others snapshot).
                // Each case also adds its OWN wallet (variant + Image upgrade) when that case's
                // wallet is toggled on and its color resolves to a matching wallet variant.
                function casesPriceTotals() {
                  var current = 0, compare = 0;
                  var wmap = (data && data.walletMap) ? data.walletMap : {};
                  for (var i = 0; i < designs.length; i++) {
                    var isActive = (i === activeIndex);
                    var d = designs[i];
                    var colorEntry = isActive ? state.colorEntry : d.colorEntry;
                    var mode = isActive ? state.personalization : d.personalization;
                    var vid = (colorEntry && colorEntry.variantId != null) ? colorEntry.variantId : null;
                    var price = (vid != null) ? variantPriceCents(vid) : 0;
                    var cmpRaw = (vid != null) ? variantCompareCents(vid) : 0;
                    var cmp = (cmpRaw > price) ? cmpRaw : price;   // not on sale → compare == current
                    var cPreset = isActive ? state.presetDesignName : d.presetDesignName;
                    var tierKey = (mode === 'Image' && cPreset) ? 'Design' : ((mode === 'Image') ? 'Image' : 'Text');
                    // Mode-gated (committed price) — matches the single-case tier display, so
                    // the total no longer drops when a Text/Image case gains a second case.
                    // Charged side (buildCartItems) stays content-gated; ATC gates reconcile.
                    var cFeeOn = (mode === 'Text' || mode === 'Image' || mode === 'Combined');
                    var up = (cFeeOn && state.upgradePrices && state.upgradePrices[tierKey]) ? (Number(state.upgradePrices[tierKey].price) || 0) : 0;
                    current += price + up;
                    compare += cmp + up;
                    // This case's wallet, if enabled and color-matched.
                    var wEnabled = isActive ? state.walletEnabled : d.walletEnabled;
                    var wMode = isActive ? state.walletPersonalization : d.walletPersonalization;
                    var cName = (colorEntry && colorEntry.colorName != null) ? colorEntry.colorName : null;
                    var wEntry = cName ? wmap[cName] : null;
                    if (wEnabled && wEntry && wEntry.available) {
                      var wPrice = Number(wEntry.priceCents) || 0;
                      var wCmpRaw = Number(wEntry.compareAtCents) || 0;
                      var wCmp = (wCmpRaw > wPrice) ? wCmpRaw : wPrice;
                      // Mode-gated (committed price) — per-case wMode; null (plain wallet) adds no fee.
                      // Fee variant follows each design's own wallet mode, matching buildCartItems.
                      var wFeeOn = (wMode === 'Text' || wMode === 'Image');
                      var wFeeKey = wMode === 'Text' ? 'Text' : 'Image';
                      var wUp = (wFeeOn && state.upgradePrices && state.upgradePrices[wFeeKey]) ? (Number(state.upgradePrices[wFeeKey].price) || 0) : 0;
                      current += wPrice + wUp;
                      compare += wCmp + wUp;
                    }
                  }
                  return { current: current, compare: compare };
                }
                // Write the COMBINED total into the prominent price spans (used when >1 case). Targets
                // and markup mirror updatePriceForVariantAndTier so it reads identically to one case.
                function updateCombinedPriceDisplay() {
                  var t = casesPriceTotals();
                  var hasDiscount = t.compare > t.current;
                  var pct = hasDiscount ? Math.round((t.compare - t.current) / t.compare * 100) : 0;
                  document.querySelectorAll('[data-cfg-price-total]').forEach(function (el) {
                    el.innerHTML = formatMoneyCents(t.current);
                  });
                  document.querySelectorAll('[data-cfg-price-compare]').forEach(function (el) {
                    if (hasDiscount) { el.innerHTML = formatMoneyCents(t.compare); el.hidden = false; }
                    else { el.hidden = true; }
                  });
                  document.querySelectorAll('[data-cfg-price-savings]').forEach(function (el) {
                    if (hasDiscount) { el.textContent = savePillTemplate.replace('{percent}', String(pct)); el.hidden = false; }
                    else { el.hidden = true; }
                  });
                }
                // The cases line shows the COUNT only (no price). >1 case → combined total drives the
                // prominent price line; 1 case → leave it to the normal single-variant price path.
                function refreshCasesTotal() {
                  if (!designs || designs.length === 0) return;
                  var n = designs.length;
                  if (casesTotalEl) casesTotalEl.textContent = n + ' case' + (n === 1 ? '' : 's');
                  if (n > 1) updateCombinedPriceDisplay();
                }

                function renderCaseTabs(enterIndex) {
                  if (!casesEl) return;
                  var addBtn = casesEl.querySelector('.cfg-add-case');
                  casesEl.querySelectorAll('.cfg-case-tab').forEach(function (t) { t.remove(); });
                  var showRemove = designs.length > 1;
                  for (var i = 0; i < designs.length; i++) {
                    var tab = document.createElement('div');
                    tab.className = 'cfg-case-tab'
                      + (i === activeIndex ? ' is-active' : '')
                      + ((!prefersReducedMotion && enterIndex === i) ? ' cfg-case-tab--enter' : '');
                    tab.setAttribute('data-cfg-case-index', String(i));
                    var sel = document.createElement('button');
                    sel.type = 'button';
                    sel.className = 'cfg-case-tab__select';
                    sel.setAttribute('data-cfg-select', String(i));
                    sel.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
                    sel.textContent = 'Case ' + (i + 1);
                    tab.appendChild(sel);
                    if (showRemove) {
                      var x = document.createElement('button');
                      x.type = 'button';
                      x.className = 'cfg-case-tab__remove';
                      x.setAttribute('data-cfg-remove', String(i));
                      x.setAttribute('aria-label', 'Remove Case ' + (i + 1));
                      x.innerHTML = '<svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
                      tab.appendChild(x);
                    }
                    if (addBtn) casesEl.insertBefore(tab, addBtn); else casesEl.appendChild(tab);
                  }
                  if (addBtn) {
                    var atMax = designs.length >= MAX_CASES;
                    addBtn.disabled = atMax;
                    addBtn.classList.toggle('is-disabled', atMax);
                    addBtn.setAttribute('aria-disabled', atMax ? 'true' : 'false');
                  }
                }

                // Toggle the active highlight WITHOUT rebuilding the tabs, so the CSS transition on
                // .cfg-case-tab (background + border-color + box-shadow) animates smoothly on switch.
                function updateActiveTabClasses() {
                  if (!casesEl) return;
                  casesEl.querySelectorAll('.cfg-case-tab').forEach(function (tab) {
                    var idx = parseInt(tab.getAttribute('data-cfg-case-index'), 10);
                    var on = (idx === activeIndex);
                    tab.classList.toggle('is-active', on);
                    var sel = tab.querySelector('.cfg-case-tab__select');
                    if (sel) sel.setAttribute('aria-current', on ? 'true' : 'false');
                  });
                }

                function switchToCase(i) {
                  if (i === activeIndex || i < 0 || i >= designs.length) return;
                  saveActiveDesign();
                  loadDesign(i);
                  updateActiveTabClasses();
                  refreshCasesTotal();
                }
                function addCase() {
                  if (designs.length >= MAX_CASES) return;
                  saveActiveDesign();
                  designs.push(makeBlankDesign());
                  loadDesign(designs.length - 1);
                  renderCaseTabs(designs.length - 1);   // animate the newly added tab in
                  refreshCasesTotal();
                }
                // Play the exit animation on the target tab, then actually remove it.
                function performRemove(i) {
                  if (designs.length <= 1 || i < 0 || i >= designs.length) return;
                  var tab = casesEl ? casesEl.querySelector('.cfg-case-tab[data-cfg-case-index="' + i + '"]') : null;
                  if (prefersReducedMotion || !tab) { removeCase(i); return; }
                  tab.classList.add('cfg-case-tab--exit');
                  setTimeout(function () { removeCase(i); }, 170);
                }
                function removeCase(i) {
                  if (designs.length <= 1 || i < 0 || i >= designs.length) return;
                  if (i === activeIndex) {
                    designs.splice(i, 1);
                    activeIndex = (i > 0) ? i - 1 : 0;
                    loadDesign(activeIndex);
                  } else {
                    saveActiveDesign();
                    designs.splice(i, 1);
                    if (i < activeIndex) activeIndex -= 1;
                    loadDesign(activeIndex);
                  }
                  renderCaseTabs();
                  refreshCasesTotal();
                }

                // ----- Remove-confirmation modal (centered, soft backdrop, fade + scale) -----
                function openRemoveModal(i) {
                  if (designs.length <= 1) return;
                  pendingRemoveIndex = i;
                  if (!removeModal) { removeCase(i); return; }
                  removeModal.hidden = false;
                  if (prefersReducedMotion) {
                    removeModal.classList.add('is-open');
                  } else {
                    requestAnimationFrame(function () { requestAnimationFrame(function () { removeModal.classList.add('is-open'); }); });
                  }
                  var keep = removeModal.querySelector('.cfg-modal__btn--cancel');
                  if (keep) setTimeout(function () { try { keep.focus(); } catch (e) {} }, prefersReducedMotion ? 0 : 90);
                }
                function closeRemoveModal() {
                  if (!removeModal) return;
                  pendingRemoveIndex = null;
                  removeModal.classList.remove('is-open');
                  if (prefersReducedMotion) {
                    removeModal.hidden = true;
                  } else {
                    setTimeout(function () { if (!removeModal.classList.contains('is-open')) removeModal.hidden = true; }, 210);
                  }
                }

                // ----- Preset-designs sheet (open/close mirrors the remove modal above) -----
                var designsModal = root.querySelector('[data-cfg-designs-modal]');
                function openDesignsModal() {
                  if (!designsModal) return;
                  designsModal.hidden = false;
                  if (prefersReducedMotion) {
                    designsModal.classList.add('is-open');
                  } else {
                    requestAnimationFrame(function () { requestAnimationFrame(function () { designsModal.classList.add('is-open'); }); });
                  }
                  var closeBtn = designsModal.querySelector('.cfg-modal__btn--cancel');
                  if (closeBtn) setTimeout(function () { try { closeBtn.focus(); } catch (e) {} }, prefersReducedMotion ? 0 : 90);
                }
                function closeDesignsModal() {
                  if (!designsModal) return;
                  designsModal.classList.remove('is-open');
                  if (prefersReducedMotion) {
                    designsModal.hidden = true;
                  } else {
                    setTimeout(function () { if (!designsModal.classList.contains('is-open')) designsModal.hidden = true; }, 210);
                  }
                }
                // Wire the entry button + build the gallery from CFG_DATA.designPresets.
                // No presets (missing key, empty array, or old cached Liquid) → the button
                // stays hidden (Push 1 shipped it with the hidden attribute) and nothing runs.
                function setupDesignPresets() {
                  var presets = data.designPresets;
                  var openBtn = root.querySelector('[data-cfg-designs-open]');
                  var listEl = designsModal ? designsModal.querySelector('.cfg-designs-list') : null;
                  if (!Array.isArray(presets) || presets.length === 0 || !openBtn || !designsModal || !listEl) return;
                  // Selected-state sync: mark the tile matching the ACTIVE case's preset (per-case
                  // state — case switches restore presetDesignName via DESIGN_FIELDS), clear the rest.
                  function syncSelectedTile() {
                    var current = state.presetDesignName ?? null;
                    listEl.querySelectorAll('.cfg-design-tile').forEach(function (t) {
                      t.classList.toggle('is-selected', current !== null && t.getAttribute('data-design-name') === current);
                    });
                  }
                  presets.forEach(function (p) {
                    if (!p || !(p.name ?? '') || !(p.full ?? '')) return;
                    // Tile markup matches the Push 1 CSS classes (.cfg-design-tile et al).
                    var item = document.createElement('button');
                    item.type = 'button';
                    item.className = 'cfg-design-tile';
                    item.setAttribute('data-design-name', p.name);
                    var swatch = document.createElement('span');
                    swatch.className = 'cfg-design-tile__swatch';
                    var thumb = document.createElement('img');
                    thumb.src = p.thumb ?? p.full;
                    thumb.alt = p.name;
                    thumb.loading = 'lazy';
                    swatch.appendChild(thumb);
                    var check = document.createElement('span');
                    check.className = 'cfg-design-tile__check';
                    check.setAttribute('aria-hidden', 'true');
                    check.textContent = '✓';
                    check.style.cssText = 'font-size:12px;line-height:1;';
                    var label = document.createElement('span');
                    label.className = 'cfg-design-tile__name';
                    label.textContent = p.name;
                    item.appendChild(swatch);
                    item.appendChild(check);
                    item.appendChild(label);
                    item.addEventListener('click', function () {
                      cfgLog('[configurator] preset design selected:', p.name);
                      // Exact upload-complete sequence (mirrors the Cloudinary success handler),
                      // plus the preset name that maps the fee to the 'Design' variant.
                      selectPersonalization('Image');
                      state.presetDesignName = p.name;
                      showUploadPreview(p.full);
                      processUploadedImageForPreview(p.full);
                      // Reflect the new selection on the tiles before the modal closes.
                      syncSelectedTile();
                      closeDesignsModal();
                    });
                    listEl.appendChild(item);
                  });
                  openBtn.hidden = false;
                  openBtn.addEventListener('click', function () {
                    // Every open re-syncs .is-selected to the active case's presetDesignName
                    // (cleared elsewhere by real uploads / image removal — see lifecycle clears).
                    syncSelectedTile();
                    openDesignsModal();
                  });
                  designsModal.addEventListener('click', function (e) {
                    if (e.target.closest('[data-cfg-designs-cancel]')) closeDesignsModal();
                  });
                  document.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape' && designsModal.classList.contains('is-open')) closeDesignsModal();
                  });
                  cfgLog('[configurator] preset designs ready:', presets.length, 'entries');
                }

                function setupCaseStrip() {
                  if (casesEl) {
                    casesEl.addEventListener('click', function (e) {
                      var add = e.target.closest('.cfg-add-case');
                      if (add) { if (!add.disabled) addCase(); return; }
                      var rem = e.target.closest('[data-cfg-remove]');
                      if (rem) { openRemoveModal(parseInt(rem.getAttribute('data-cfg-remove'), 10)); return; }
                      var sel = e.target.closest('[data-cfg-select]');
                      if (sel) { switchToCase(parseInt(sel.getAttribute('data-cfg-select'), 10)); return; }
                    });
                  }
                  if (removeModal) {
                    removeModal.addEventListener('click', function (e) {
                      if (e.target.closest('[data-cfg-modal-confirm]')) {
                        var idx = pendingRemoveIndex;
                        closeRemoveModal();
                        if (idx != null) performRemove(idx);
                      } else if (e.target.closest('[data-cfg-modal-cancel]')) {
                        closeRemoveModal();
                      }
                    });
                    document.addEventListener('keydown', function (e) {
                      if (e.key === 'Escape' && removeModal.classList.contains('is-open')) closeRemoveModal();
                    });
                  }
                }

                try {
                  initLivePreview();
                  buildMenu();
                  selectModel(sortedModels[0]);
                  // No personalization mode is pre-selected — the customer must actively pick
                  // Text or Image before any fee shows. selectPersonalization(null) leaves both
                  // pills inactive, hides both panels + sliders, disables propType/propText/
                  // propImage/propFont, and prices the 'none' (base, fee-free) tier.
                  selectPersonalization(null);
                  // Multi-case (Stage 2): seed the array with Case 1 (the design just initialized
                  // above), render the tab strip, and wire switching / add / remove + modal.
                  designs = [ snapshotActiveDesign() ];
                  activeIndex = 0;
                  renderCaseTabs();
                  setupCaseStrip();
                  setupDesignPresets();
                  refreshCasesTotal();
                  // Fire upgrade-product fetch in the background. Pill sub-label TEXT is
                  // already Liquid-rendered; this fetch just resolves the upgrade variant IDs
                  // that buildCartItems needs to build the cart's second line item.
                  fetchUpgradePrices();
                  // Initial pill sub-label visibility (active span on the default Text pill,
                  // inactive spans on the other two) — both spans are in the DOM already.
                  updatePillSubLabelVisibility();
                  // Initial main price sync — Liquid painted the base (fee-free) price and the
                  // init path above re-applied the same 'none' tier via selectColor /
                  // selectPersonalization(null), so this only matters when variantInput.value
                  // disagrees with the default variant (e.g. a third-party app rewrote the
                  // hidden input). Raw tier: normalizeTierKey maps null → 'none'. Safe to call.
                  if (variantInput && variantInput.value) {
                    updatePriceForVariantAndTier(variantInput.value, state.personalization);
                  }

                  if (livePreviewActive) {
                    if (document.fonts && document.fonts.ready) {
                      document.fonts.ready.then(function () {
                        cfgLog('[configurator] fonts loaded - preview rendering enabled');
                        initialRenderTrigger();
                      });
                    } else {
                      setTimeout(initialRenderTrigger, 500);
                    }
                  }
                } catch (err) {
                  console.error('[configurator] init error - falling back to img mode:', err);
                  if (originalImg) originalImg.style.display = '';
                  if (previewCanvas) previewCanvas.style.display = 'none';
                }
  }
  function boot(scope) {
    var els = (scope || document).querySelectorAll("[id^=\"configurator-\"]");
    for (var i = 0; i < els.length; i++) initConfigurator(els[i]);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else { boot(document); }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target || document); });
})();
